import type { I18nTranslations } from './i18n-en';

const i18n_ru: I18nTranslations = {
  close_btn: 'Закрыть',
  search_placeholder: 'Поиск',
  loading: 'Загрузка',

  label_inactive: 'Неактивный',
  label_invalid: 'Недействительный',

  active_devices: 'Устройств {{devices_len}} активно',
  change_language: 'Изменение языка',
  language_changed_message: 'Язык изменен',

  error_select_device_message: 'Сначала выберите устройство',
  select_device: 'Выберите устройство',
  select_company_menu_message: 'Выберите компанию, чтобы просмотреть список устройств',
  select_company_required_header: 'Выберите компанию для продолжения',
  select_company_required_from: 'Отсюда: ',
  select_company_required_accounts_page_link: 'Страница аккаунтов',

  second: 'секунда',
  seconds: 'секунды',
  second_one: 'секунда',
  second_other: 'секунды',
  minute: 'минута',
  minutes: 'минуты',
  minute_one: 'минута',
  minute_other: 'минуты',
  hour: 'час',
  hours: 'часы',
  hour_one: 'час',
  hour_other: 'часы',
  day: 'день',
  day_one: 'день',
  day_other: 'дней',
  start_date: 'Дата Начала',
  end_date: 'Дата Окончания',
  from_date: 'С Даты',
  to_date: 'Встретиться',
  avg_from_date: 'Среднее значение с даты',
  avg_to_date: 'Среднее на сегодняшний день',
  period: 'Период',
  description: 'Описание',
  date: 'Дата',
  number: 'Номер',
  apply: 'Применять',
  update: 'Обновить',
  create: 'Создайте',
  delete: 'Удалять',
  export: 'Экспорт',
  rssi: 'rssi',
  ber: 'ber',
  reading: 'Считывание',
  model: 'Модель',
  email_address: 'Адрес Электронной Почты',
  password: 'Пароль',
  confirm_password: 'Подтвердить Пароль',
  sign_in: 'Войти в Систему',
  graph: 'График',
  no_data: 'Нет Данных',
  every: 'Всякий',
  for_company: 'Для компании',
  flow: 'Поток',
  no_data_found: 'Данные не найдены.',
  percent: 'Процентов',
  device_number_devicenum: 'Номер устройства: {{device_number}}',
  device_number: 'Номер устройства',
  device_name: 'Имя устройства',
  successfully_saved: 'Успешно сохранено',
  error_occured: 'Произошла ошибка',
  none: 'Никто',
  off: 'Выкл',
  no_unit: 'Без единицы измерения',
  hardware_version: 'Версия Оборудования',
  software_version: 'Версия Программного Обеспечения',
  transmission_period: 'Период Передачи',
  record_period: 'Период записи',
  replacement_number: 'Запасной номер',
  replaced_by: 'Заменено на',

  createdOn: 'Создано',
  createdBy: 'Создано',

  show_average: 'Εμφάνιση μέσου όρου',
  show_readings: 'Εμφάνιση αναγνώσεων',

  yes: 'Да',
  no: 'Нет',
  capital_yes: 'ДА',
  capital_no: 'НЕТ',

  sensor: 'Сензор',

  all_sensors: 'Все датчики',

  select_all: 'Выбрать все',
  deselect_all: 'Отменить выбор',

  function_last: 'Last',
  function_first: 'First',
  function_avg: 'Average',
  function_min: 'Min',
  function_max: 'Max',
  function_median: 'Median',
  function_count: 'Count',
  function_last_flow: 'Last Flow',
  function_first_flow: 'First Flow',
  function_avg_flow: 'Average Flow',
  function_max_flow: 'Max Flow',
  function_min_flow: 'Min Flow',
  function_median_flow: 'Median Flow',

  page_title_header_number_with_name_absent: '{{title}} - {{device_number}}',
  page_title_header_number_with_name_present: '{{title}} - {{device_name}} ({{device_number}})',

  error_forbidden_operation_not_allowed: 'Недопустимо',

  not_set: 'Не установлено',

  // Sensor Types
  generic_analog_sensor: 'Генераторный аналоговый датчик',
  generic_virtual_sensor: 'Генераторный виртуальный датчик',
  generic_digital_sensor: 'Общий цифровой датчик',
  modbus_generic_analog_sensor: 'Общий аналоговый датчик Modbus',
  modbus_generic_digital_sensor: 'Общий цифровой датчик Modbus',
  pressure_sensor: 'Датчик давления',
  temperature_sensor: 'Датчик температуры',
  humidity_sensor: 'Датчик влажности',
  level_sensor: 'Датчик уровня',
  weight_meter: 'Весовой метр',
  weight_sensor: 'Весовой датчик',
  load_cells: 'Датчики нагрузки',
  wind_direction_sensor: 'Датчик направления ветра',
  barometric_pressure_sensor: 'Барометрический датчик давления',
  soil_moisture_sensor: 'Датчик влажности почвы',
  dew_point_sensor: 'Датчик точки росы',
  soil_temperature_sensor: 'Датчик температуры почвы',
  soil_potential_sensor: 'Датчик потенциала почвы',
  particulate_matter_sensor: 'Датчик взвешенных частиц',
  leaf_wetness_sensor: 'Датчик влажности листьев',
  gnss_sensor: 'Датчик GNSS',
  water_meter: 'Водяной счётчик',
  power_meter: 'Электросчётчик',
  gas_flow_meter: 'Счётчик расхода газа',
  rain_sensor: 'Датчик дождя',
  wind_speed_sensor: 'Датчик скорости ветра',
  heat_meter: 'Теплосчётчик',
  geiger_mueller_counter: 'Счётчик Гейгера-Мюллера',
  on_off_sensor: 'Сенсор Вкл./Выкл.',
  on_off_input_sensor: 'Сенсор Вход Вкл./Выкл.',
  on_off_output_sensor: 'Сенсор Выход Вкл./Выкл.',
  on_off_auto_output_sensor: 'Сенсор Выход Вкл./Выкл./Авто',
  tasmota_relay_sensor: 'Сенсор Реле Tasmota',
  modbus_generic_on_off_input_sensor: 'Общий сенсор входа Вкл./Выкл. Modbus',
  modbus_generic_on_off_output_sensor: 'Общий сенсор выхода Вкл./Выкл. Modbus',
  co_sensor: 'CO датчик',
  no2_sensor: 'NO2 датчик',
  so2_sensor: 'SO2 датчик',

  // Port Types
  digital_input_port: 'Цифровой Входной Порт',
  pulse_input_port: 'Импульсный Входной Порт',
  pulse_s0_input_port: 'Импульсный S0 Входной Порт',
  analog_input_port: 'Аналоговый Входной Порт',
  '4_20_mA_input_port': 'Входной Порт 4-20мА',
  '0_5_V_input_port': 'Входной Порт 0-5В',
  on_off_input_port: 'Входной Порт Вкл/Выкл',
  on_off_output_port: 'Выходной Порт Вкл/Выкл',
  generic_modbus_on_off_input_port: 'Общий Modbus Входной Порт Вкл/Выкл',
  generic_modbus_on_off_output_port: 'Общий Modbus Выходной Порт Вкл/Выкл',

  // duration
  duration_years_one: '{{count}} год',
  duration_years_other: '{{count}} лет',
  duration_months_one: '{{count}} месяц',
  duration_months_other: '{{count}} месяцев',
  duration_months_abbr: 'мес.',
  duration_days_one: '{{count}} день',
  duration_days_other: '{{count}} дней',
  duration_hours_one: '{{count}} час',
  duration_hours_other: '{{count}} часа',
  duration_minutes_one: '{{count}} минута',
  duration_minutes_other: '{{count}} минуты',
  duration_seconds_one: '{{count}} секунда',
  duration_seconds_other: '{{count}} секунды',

  years: 'Лет',
  months: 'Месяцев',
  days: 'Дней',

  /*
   * |===============|
   * | Period Picker |
   * |===============|
   */
  period_date_range: 'Диапазон дат',
  period_custom: 'Обычай',
  period_today: 'Сегодня',
  period_week: 'Неделю',
  period_month: 'Месяц',
  period_yesterday: 'Вчера',
  period_last_week: 'На прошлой неделе',
  period_last_month: 'Прошлый месяц',
  period_last_1_hours: 'Последний час',
  period_last_2_hours: 'Последние 2 часа',
  period_last_4_hours: 'Последние 4 часа',
  period_last_24_hours: 'Последние 24 часа',
  period_last_48_hours: 'Последние 48 часа',

  /*
   * |=====================|
   * | Hook Error Messages |
   * |=====================|
   */
  error_cannot_fetch_device: 'Не удалось получить устройство.',
  error_cannot_fetch_device_config: 'Не удалось получить конфигурацию устройства.',
  error_cannot_fetch_ports_config: 'Не удалось получить конфигурацию портов.',
  error_cannot_fetch_flow_stats: 'Не удалось получить статистику потоков.',
  error_cannot_fetch_time_stats: 'Не удалось получить статистику времени.',
  error_cannot_fetch_general_stats: 'Не удалось получить общую статистику.',
  error_cannot_fetch_qflow_stats: 'Не удалось получить статистику qflow.',

  signup_company_name: 'Название Компании',

  sign_up_form_first_name: 'Имя',
  sign_up_form_last_name: 'Фамилия',
  sign_up_form_email: 'Адрес Электронной Почты',
  sign_up_form_password: 'Пароль',
  sign_up_form_confirm_password: 'Подтвердите Пароль',
  sign_up_form_company_name: 'Название Компании',

  button_save: 'Сохранить',
  button_apply: 'Применять',
  button_update: 'Обновить',
  button_create: 'Создайте',
  button_delete: 'Удалять',
  button_continue: 'Продолжить',
  button_back: 'Назад',
  dashboard_tour_back: 'Назад',
  dashboard_tour_next: 'Далее',
  dashboard_tour_finish: 'Завершить',
  dashboard_tour_close: 'Закрыть',
  dashboard_tour_open: 'Открыть диалог',
  dashboard_tour_skip: 'Пропустить',
  dashboard_tour_next_with_progress: 'Далее ({current} из {total})',
  capital_add_btn: 'ДОБАВИТЬ',
  capital_create_btn: 'СОЗДАЙТЕ',
  capital_update_btn: 'ОБНОВИТЬ',
  capital_remove_btn: 'УДАЛИТЬ',
  capital_cancel_btn: 'ОТМЕНИТЬ',

  role_roles: 'Роли',
  role_user: 'Пользователь',
  role_admin: 'Админ',
  role_billing: 'Выставление счетов',
  role_public: 'Публичный',
  role_super_admin: 'Супер администратор',
  role_restricted: 'Ограниченный',

  device_counters_cumulative_graph_graph: 'График, номер устройства: {{device_number}}',
  device_counters_cumulative_graph_must_have_analog_sensor:
    'Должен быть активирован аналоговый датчик.',

  sensor_statistics_min: 'Мин: {{min}}',
  sensor_statistics_max: 'Макс: {{max}}',
  sensor_statistics_avg: 'Средн: {{avrg}}',
  sensor_statistics_total: 'Общее: {{total}}',

  chart_statistics_min: 'Мин:',
  chart_statistics_max: 'Макс:',
  chart_statistics_avg: 'Средн:',
  chart_statistics_total: 'Общее:',

  menu_main: 'Основной',
  menu_device: 'Устройство',

  submenu_devices: 'Устройства',
  submenu_account: 'Счет',
  submenu_device_reports: 'Отчеты об устройствах',
  submenu_settings: 'Настройки',

  link_selected_device: 'Выбранное Устройство',
  link_device_nodes: 'Устройственные узлы',
  link_devices: 'Список устройств',
  link_accounts: 'Счета',
  link_utility_rate: 'Тарифы',
  link_link_device: 'Связать Устройство',
  link_create_user: 'Создать Пользователя',
  link_icons: 'Значки',
  link_licenses: 'Лицензии',
  link_accounts_manager: 'Управлять Учетными Записями',
  link_transmissions: 'Трансмиссии',
  link_map: 'Карта',
  link_inventory: 'Инвентарь',
  link_devices_manager: 'Диспетчер Устройств',
  link_battery: 'Батарея',
  device_groups: 'Группы устройств',
  link_signal: 'Сигнал',
  link_alarms: 'Сигнал Тревоги',
  link_value_ranges: 'События диапазона значений',
  link_device_account_lookup: 'Поиск устройства',
  link_show_users: 'Пользователи',
  link_dashboard: 'Приборная Панель',
  link_dashboard_2: 'Приборная Панель 2',
  link_reports: 'Отчеты',
  link_scheduled_reports: 'Запланированные Отчеты',
  link_billing_report: 'Отчет по оплате',

  link_all_devices: 'Все Устройства',
  link_readings: 'Чтения',
  link_sensors_data: 'Данные сенсоров',
  link_flow: 'Поток',
  link_graph: 'График',
  link_new_graph: 'Мгновенный График',
  link_pump_control: 'Pump Control',
  link_relay_control: 'Relay Control',
  link_alarm_config: 'Конфигурация Сигнализации',
  link_statistics: 'Статистика',
  link_customer: 'Покупатель',
  link_meter: 'Метр',
  link_config: 'Синхронизация конфигурации',
  link_initial_config: 'Начальная Конфигурация (старая)',
  link_sensor_config: 'Конфигурация Датчика (старая)',
  link_sensors_and_network_config: 'Конфигурация параметров',
  link_export: 'Экспорт',
  link_customer_billing_report: 'Отчет о выставлении счетов клиентам',
  link_flow_generator: 'Генератор Потока',
  link_commands: 'Команды',
  link_copy_config: 'Копировать Конфигурацию',
  switch_to_new_menu_label: 'Использовать новое меню',
  switch_to_old_menu_label: 'Использовать старое меню',
  link_profile: 'Профиль',
  link_language: 'Язык',
  link_sign_out: 'Выход',

  chip_early_access: 'Ранний Доступ',

  pulse_sensor_1: 'Датчик Пульса 1',
  pulse_sensor_2: 'Датчик Пульса 2',
  analog_sensor_1: 'Аналоговый Датчик 1',
  analog_sensor_2: 'Аналоговый Датчик 2',
  analog_sensor_3: 'Аналоговый Датчик 3',
  analog_sensor_4: 'Аналоговый Датчик 4',
  analog_sensor_5: 'Датчик 1',
  analog_sensor_6: 'Датчик 2',
  analog_sensor_7: 'Датчик 3',
  analog_sensor_8: 'Датчик 4',
  on_off_sensor_1: 'Датчик Вкл/Выкл 1',
  on_off_sensor_2: 'Датчик Вкл/Выкл 2',
  on_off_sensor_3: 'Реле Вкл/Выкл 1',
  on_off_sensor_4: 'Реле Вкл/Выкл 2',

  device_icon: 'Значок устройства',
  sensor_icon: 'Значок датчика',
  icon_no_icon: 'Нет Значка',
  icon_barometer: 'Барометр',
  icon_door_closed: 'Дверь Закрыта',
  icon_door_open: 'Открытая Дверь',
  icon_electricity: 'Электричество',
  icon_energy_meter: 'Счетчик Энергии',
  icon_gas_flow_meter: 'Расходомер Газа',
  icon_gas: 'Газ',
  icon_generic_particle_meter: 'Общий измеритель Частиц',
  icon_generic: 'Общий',
  icon_heat_meter: 'Теплосчетчик',
  icon_humidity: 'Влажность',
  icon_leaf_moisture: 'Влажность Листьев',
  icon_level_metering: 'Измерение Уровня',
  icon_pivot: 'Вращаться',
  icon_pressure: 'Давление',
  icon_radiation: 'Радиация',
  icon_rain: 'Дождь',
  icon_soil_moisture: 'Влажность Почвы',
  icon_temperature: 'Температура',
  icon_water_meter: 'Водомер',
  icon_water: 'Вода',
  icon_wind_direction: 'Направление Ветра',
  icon_wind_speed: 'Скорость Ветра',
  icon_pump: 'Насос',
  icon_apartment: 'Жилой Дом',
  icon_base_station: 'Базовая Станция',
  icon_clinic: 'Клиника',
  icon_hospital: 'Больница',
  icon_house: 'Дом',
  icon_mayor_office: 'Здание Мэрии',
  icon_police_station: 'Полицейский Участок',
  icon_public_restroom: 'Общественный Туалет',
  icon_stadium: 'Стадион',
  icon_gas_station: 'Автозаправочная станция',
  icon_controller: 'Контроллер',

  device_icon_new_portal: 'Иконка (новый портал)',
  device_icon_old_portal: 'Иконка (старый портал)',

  very_low_level_alarm: 'Сигнализация очень низкого уровня',
  low_level_alarm: 'Сигнализация низкого уровня',
  high_level_alarm: 'Сигнализация высокого уровня',
  very_high_level_alarm: 'Сигнализация очень высокого уровня',

  sensor_conversion_formula: 'Формула преобразования датчика',
  delete_old_counters: ' Удалить старые отчеты',
  device_config_select_record_period: 'Выберите период записи',
  device_config_select_transmission_period: 'Выберите период передачи',

  devices_table_number: 'Число',
  devices_table_name: 'Имя',
  devices_table_device_number: 'Номер устройства',
  devices_table_device_name: 'Имя устройства',
  devices_table_business_partner: 'Деловой партнер',
  devices_table_quarter: 'Квартал',
  devices_table_address: 'Адрес',
  devices_table_error: 'Не удалось загрузить устройства',
  devices_table_no_devices_found: 'Нет обнаруженных устройств',
  devices_table_description: 'Описание',
  devices_column_header_search: 'Поиск...',

  alarm_config_header: 'Настройка сигнализации',
  alarm_config_notification_email: 'Уведомления по электронной почте',
  alarm_config_notification_email_place_holder: 'Список рассылки (через запятую)',
  alarm_config_missed_transmission_email: 'Адреса электронной почты для пропущенных передач',
  alarm_config_missed_transmission_email_place_holder:
    'Список адресов электронной почты для пропущенных передач (через запятую)',
  alarm_config_high_consumption_threshold:
    'Высокий Порог Потребления для периода передачи {{transmission_every}} {{transmission_period}} [{{units}}]',
  alarm_config_low_flow_alarm_threshold:
    'Порог Срабатывания Сигнализации Низкого Расхода [{{units}}]',
  alarm_config_high_flow_alarm_threshold:
    'Порог Срабатывания Сигнализации Высокого Расхода [{{units}}]',
  alarm_config_non_zero_consumption_time_range: 'Диапазон времени ненулевого потребления',
  alarm_config_high_low_flow_time_range: 'Интервал времени для большого/малого расхода',
  alarm_config_start_time: 'Начальное время',
  alarm_config_end_time: 'Время окончания',
  alarm_config_flow_calc_time_base: 'Временная база расчета расхода',
  alarm_config_saved_msg: 'Конфигурация Сигнализации Сохранена.',
  alarm_config_email_validation_error:
    'Пожалуйста, введите действительные адреса электронной почты, разделенные одной запятой и без пробела, максимум 255 символов.',

  alarm_config_non_zero_consumption_time_range_error:
    'Должно быть указано время начала и время окончания',
  alarm_config_low_flow_severity: 'Серьезность низкого потока',
  alarm_config_high_flow_severity: 'Серьезность высокого потока',
  alarm_config_high_consumption_severity: 'Серьезность высокого потребления',
  alarm_config_all_zero_severity: 'Серьезность нулевого потребления',
  alarm_config_non_zero_consumption_severity: 'Серьезность ненулевого потребления',
  alarm_config_on_off_severity: 'Серьезность включения/выключения',

  alarms_title: 'Сигнал Тревоги',
  alarms_title_with_dev_num: 'Сигналы тревоги, номер устройства: {{device_number}}',
  alarms_type: 'Тип Тревоги',
  alarms_active_status: 'Активность',
  alarms_active_dropdown_label: 'Активный',
  alarms_inactive_dropdown_label: 'Неактивный',

  device_battery_title: 'Уровень заряда батареи',
  device_battery_voltage: 'Вольтаж, mV',
  device_battery_level: 'Уровень, %',

  device_signal_title: 'Сила сигнала',

  device_counters_graph_header: 'График Потребления',

  device_instant_graph_header: 'Мгновенный График',

  devices_signal_title: 'Сигнал устройств',
  devices_signal_level: 'Уровень сигнала',
  devices_signal_level_percent: 'Уровень, %',

  devices_battery_title: 'Уровень Заряда Батарей',
  devices_battery_level: 'Уровень Заряда Батареи, %',
  devices_battery_voltage: 'Вольтаж, mV',

  reports_export_title: 'Экспорт Отчетов в файл',

  device_counter_export_title: 'Экспорт Счетчиков Устройств, номер устройства: {{device_number}}',

  device_config_record_and_transmission_period: 'Периоды записи и передачи',
  device_config_record_period: 'Период Записи',
  device_config_transmission_period: 'Период Передачи',
  device_config_start_setup: 'Начать Настройку',
  device_config_setup_message:
    'Конфигурация Сохранена. Теперь поместите магнит на ваше устройство.',
  device_config_header: 'Настроить устройство',
  device_config_config_date: 'Дата конфигурации: {{date}}',
  device_config_config_status: 'Статус',
  device_config_config_status_configured: 'Синхронизировано',
  device_config_config_status_not_configured: 'Не синхронизировано',
  device_config_time_zone: 'Часовой пояс',
  device_config_pulse_per: '{{x}} за импульс',
  device_config_sensor_type: 'Тип Датчика',
  device_config_meter_type: 'Тип Счетчика',
  device_config_select_time_zone: 'Выберите часовой пояс',
  device_config_missed_transmission_alarm_severity:
    'Тяжесть аварийного сигнала о пропущенной передаче',
  device_config_pulse_coef_not_changed_message:
    'Предупреждение: Пользовательский "Коэффициент импульсов" остается неизменным при изменении "Первоначальное Чтение"',
  device_config_does_not_support_this_model:
    'Эта модель устройства не поддерживается на этой странице.',

  device_digits_fraction: 'Дробь',
  device_digits_digits: 'Цифры',
  device_digits_initial_reading: 'Первоначальное Чтение',
  device_digits_alert_too_many_total_digits: 'Общее количество цифр должно быть <= 9',
  device_digits_alert_too_small_total_digits: 'Общее количество цифр должно быть >= 4',
  device_digits_alert_too_many_total_fraction:
    'Количество цифр после десятичной точки должно быть <= 3, а общее количество цифр должно быть <= 9.',
  device_digits_alert_too_small_total_fraction:
    'Количество цифр после десятичной точки должно быть> = 0, а общее количество цифр должно быть> = 4.',

  device_transmissions_at: 'Передачи устройства в {{query_date}}',
  device_transmissions_last_transmission_short: 'Последний пер.',
  device_transmissions_next_transmissions_short: 'Следующий пер.',
  device_transmissions_days: 'Дней',
  device_transmissions_transmissions_short: 'Пер',
  device_transmissions_count: 'Считать',
  device_transmissions_fail: 'Потерпеть Поражение',
  device_transmissions_customer: 'Клиент',
  device_transmissions_address: 'Адрес',
  device_transmissions_ok: 'Ок',

  link_device_link_device_to_my_account: 'Свяжите устройство с моей учетной записью',
  link_device_device_number: 'Номер Устройства',
  link_device_unlink_device: 'Отменить Связь с Устройством',
  link_device_with_device_number: `Связать устройство: {{device_number}}`,
  unlink_device_with_device_number: `Отключить устройство: {{device_number}}`,
  link_device_devices_counts:
    'Связанные устройства: {{linked_devices_count}} / {{allowed_devices_count}}',
  link_device_success_message: 'Устройство успешно связано',
  unlink_device_success_message: 'Устройство успешно отключено от: ',
  link_device_enter_device_number_error: 'Введите номер устройства',
  link_device_select_company_error: 'Выберите компанию',
  link_device_default_error: 'Произошла проблема при связывании/отвязывании устройства',
  link_device_company_not_found_error: 'Компания не найдена',
  link_device_device_not_found_error: 'Устройство {{device_number}} не найдено',
  link_device_device_not_linked_error: 'Устройство {{device_number}} не связано',
  link_device_device_already_linked_error: 'Устройство {{device_number}} уже связано',
  link_device_device_limit_reached_error: 'Достигнут предел устройств',
  link_device_operation_not_allowed_error: 'Операция не разрешена',
  link_device_unlink_devices_for_sub_accounts: 'Отключить устройство для всех субаккаунтов',
  link_device_unlink_devices_for_sub_accounts_tooltip:
    'Если отмечено, устройство будет отключено от выбранного аккаунта и всех субаккаунтов. Если не отмечено, устройство будет отключено только для выбранного аккаунта.',
  link_device_lookup_title: 'Поиск устройства',
  link_device_lookup_subheader:
    'Нажмите на строку в этой таблице, чтобы автоматически подставить номер устройства в форму привязки.',
  link_device_lookup_filter_number: 'Номер',
  link_device_lookup_filter_name: 'Имя',
  link_device_lookup_device_name: 'Имя устройства',
  link_device_lookup_device_number: 'Номер устройства',
  link_device_lookup_no_devices_found: 'Устройства не найдены',

  device_search_device_number: 'Номер Устройства',
  device_search_kicker: 'Контекст компании',
  device_search_title: 'Поиск компании по устройству',
  device_search_subtitle:
    'Найдите по номеру устройства и выберите компанию, которая должна оставаться активной в management.',
  device_search_device_number_placeholder: 'Введите номер устройства',
  device_search_length_hint: 'Поиск начинается автоматически, когда вы перестаете печатать.',
  device_search_clear: 'Очистить',
  device_search_selected_company: 'Выбранная компания',
  device_search_selected_company_hint:
    'Нажмите на ту же строку еще раз, чтобы очистить текущий выбор компании.',
  device_search_error: 'Не удалось загрузить компании для этого номера устройства.',
  device_search_no_matches: 'Для этого номера устройства компании не найдены.',
  device_search_results_title: 'Подходящие компании',
  device_search_results_ready: 'Выберите строку, чтобы обновить активный контекст компании.',
  device_search_results_waiting: 'Введите номер устройства, чтобы начать поиск.',
  device_search_empty_prompt: 'Введите номер устройства, чтобы искать подходящие компании.',
  device_search_empty_prompt_subtitle: 'Результаты появятся здесь, когда вы перестанете печатать.',
  device_search_domain: 'Домен',

  device_manager_create_or_delete_device: 'Создать или удалить устройство: {{device_number}}',
  device_manager_device_number: 'Номер Устройства',
  device_manager_device_model: 'Модель Устройства',
  device_manager_sw_version_validation:
    'Требуемый формат: X.X.X или X.X.X- и X.X.X_, за которыми следуют символы, где X - число',
  device_manager_hw_version_validation: 'Требуемый формат - X.X.X, где X - число',
  device_manager_software_version: 'Версия Программного Обеспечения',
  device_manager_hardware_version: 'Версия Оборудования',

  dashboard_alarms: 'Сигнал Тревоги',
  dashboard_batteries: 'Батареи',
  dashboard_signal: 'Сигнал',
  dashboard_transmission: '{{alarm_type}} ({{alarm_count}})',
  dashboard_chart_battery_level: 'Уровень заряда батареи',
  dashboard_chart_signal_level: 'Уровень сигнала',
  dashboard_chart_number_of_devices: 'Количество устройств',
  dashboard_select_company_header: 'Выберите аккаунт для просмотра панели управления',
  dashboard_select_company_from: 'Отсюда: ',
  dashboard_select_company_accounts_page_link: 'Аккаунты',

  alarm_type_no_zero_consumption: 'Нет Нулевого Потребления',
  alarm_type_high_consumption: 'Высокое Потребление',
  alarm_type_high_flow: 'Высокий Расход',
  alarm_type_missed_transmission: 'Пропущенная Передача',
  alarm_type_low_flow: 'Низкий поток',
  alarm_type_all_zero_consumption: 'Полностью Нулевое Потребление',
  alarm_type_device_removed: 'Устройство Удалено',
  alarm_type_on_off_alarm: 'Вкл/Выкл Сигнал Тревоги',
  alarm_type_low_level: 'Сигнализация Низкого Уровня',
  alarm_type_high_level: 'Сигнализация Высокого Уровня',
  alarm_type_tamper: 'Тампер',
  alarm_type_oversized: 'Негабаритный',
  alarm_type_undersized: 'Малоразмерный',
  alarm_type_low_battery: 'Низкий Заряд Батареи',
  alarm_type_blockage: 'Блокировка',
  alarm_type_burst: 'Лопаться',
  alarm_type_reverse_flow: 'Обратный поток',
  alarm_type_range_event: 'Событие диапазона',
  alarm_type_very_low_level: 'Очень низкий уровень',
  alarm_type_very_high_level: 'Очень высокий уровень',
  alarm_type_leakage: 'Утечка',
  alarm_type_low_temperature: 'Низкая температура',
  alarm_type_no_consumption: 'Нет потребления',
  alarm_type_negative_flow: 'Отрицательный поток',
  alarm_type_empty_spool: 'Пустая труба',
  alarm_type_combination_of_alarms: 'Комбинация аварий',
  alarm_type_standstill: 'Простой',
  alarm_type_reset_error: 'Ошибка сброса',
  alarm_type_rf_error: 'Ошибка RF',
  alarm_type_cs_error: 'Ошибка CS',
  alarm_type_measuring_error: 'Ошибка измерения',
  alarm_type_reset_event: 'Сброс',
  alarm_type_magnetic_field: 'Магнитное поле',
  alarm_type_sensor_fraud: 'Вмешательство в датчик',

  device_counter_graph_min: 'Мин: {{min}}',
  device_counter_graph_max: 'Макс: {{max}}',
  device_counter_graph_avg: 'Средн: {{avrg}}',
  device_counter_graph_total: 'Общее: {{total}}',
  device_counter_graph_average: 'В среднем:',
  device_counter_graph_no_data: 'Нет данных',
  device_counter_graph_cant_calculate_flow_analog:
    'Невозможно рассчитать расход для аналогового датчика!',
  device_counter_graph_must_have_digital_sensor: 'Должен быть включен цифровой датчик.',

  customer_info_header: 'Информация о Kлиенте',
  customer_info_business_partner_number: 'Номер Бизнес-Партнера',
  customer_info_contact_data: 'Контактные Данные',
  customer_info_contract_number: 'Договор',
  customer_info_name: 'Название',
  customer_info_description: 'Описание',
  customer_info_billing_group: 'Группа выставления счетов',
  customer_info_municipality: 'Муниципалитет',
  customer_info_quarter: 'Квартал',
  customer_info_street: 'Улица',
  customer_info_block: 'Жилой Дом',
  customer_info_entr: 'Вход',
  customer_info_customer_type: 'Тип Клиента',
  customer_info_customer_type_commercial: 'Коммерческий',
  customer_info_customer_type_domestic: 'Внутренний',
  customer_info_customer_type_block_of_flats: 'Жилой дом',
  customer_info_customer_type_budget: 'Бюджет',

  meter_info_meter_info: 'Информация о Счетчике: {{device_number}}',
  meter_info_factory_number: 'Заводской Номер',
  meter_info_brand: 'Марка',
  meter_info_enter_diameter: 'Введите Диаметр',
  meter_info_mount_date: 'Дата Установки',
  meter_info_meter_info_saved: 'Информация о Счетчике Сохранена.',

  device_initial_config_header: 'Начальная Конфигурация Устройства',
  device_initial_device_model: 'Модель Устройства',
  device_initial_config_address: 'Адрес',
  device_initial_config_port: 'Порт',
  device_initial_config_resolve_address: 'Разрешить Адрес (использовать DNS)',
  device_initial_config_simcard_provider: 'Провайдер сим-карты',
  device_initial_config_simcard_number: 'Номер сим-карты',
  device_initial_config_bands: 'bands',
  device_initial_config_OTAA_appkey: 'OTAA - appkey',
  device_initial_config_OTAA_deveui: 'OTAA - deveui',
  device_initial_config_OTAA_appeui: 'OTAA - appeui',
  device_initial_config_ABP_appskey: 'ABP - appskey',
  device_initial_config_ABP_nwkskey: 'ABP - nwkskey',
  device_initial_config_ABP_devaddr: 'ABP - devaddr',
  device_initial_config_ABP_deveui: 'ABP - deveui',
  device_initial_config_lora_app_mode: 'Режим приложения',
  device_initial_config_app_id: 'ID приложения',
  device_initial_config_profile_id: 'ID профиля',
  device_initial_config_platform_name: 'Название платформы',
  device_initial_config_thingslog_lora_platform: 'Платформа ThingsLog LoRa',
  device_receive_data_binary: 'Получение двоичных данных',
  device_send_data_binary: 'Отправить двоичные данные',
  device_mqtt_config: 'MQTT конфигурация',
  device_mqtt_config_qos: 'Качество обслуживания',
  device_mqtt_config_username: 'Имя пользователя',
  device_mqtt_config_password: 'Пароль',
  device_mqtt_config_certificate: 'Сертификат',
  device_initial_config_apn_username: 'Имя пользователя APN',
  device_initial_config_apn_password: 'Пароль APN',
  device_initial_config_gprs_radio_mode: 'Режим GPRS-радио',
  device_initial_config_grps_radio_mode_auto_option: 'Авто',
  device_initial_config_net_attached_delay: 'Время ожидания',
  device_initial_config_preferred_network_type: 'Предпочтительный Тип Сети',
  device_initial_config_preferred_network_default_option: 'По умолчанию',
  device_initial_config_mcc_mnc: 'MCC-MNC',
  device_initial_config_slave_devices: 'Ведомые устройства',
  device_initial_config_modbus_address: 'Адрес Modbus',
  device_initial_config_modbus_master_device: 'Номер главного устройства',
  device_initial_config_trashcan_brand: 'Бренд',
  device_initial_config_trashcan_model: 'Модель',
  device_initial_config_trashcan_volume: 'Объем',
  device_initial_config_trashcan_max_weight: 'Максимальный вес',
  device_initial_config_trashcan_material: 'Материал',
  device_initial_config_trashcan_color: 'Цвет',
  device_initial_config_trashcan_waste_type: 'Тип отходов',
  device_initial_config_trashcan_waste_type_plastic: 'Пластик',
  device_initial_config_trashcan_waste_type_bio: 'Био',
  device_initial_config_trashcan_waste_type_paper: 'Бумага',
  device_initial_config_trashcan_waste_type_glass: 'Стекло',
  device_initial_config_trashcan_waste_type_metal: 'Металл',
  device_initial_config_trashcan_waste_type_mixed: 'Смешанные',
  device_initial_config_trashcan_waste_type_other: 'Другое',
  device_initial_config_trashcan_pricing: 'Ценообразование',
  device_initial_config_trashcan_pricing_free: 'Бесплатно',
  device_initial_config_trashcan_pricing_per_lift: 'За вывоз',
  device_initial_config_trashcan_pricing_per_kg: 'За килограмм',
  device_initial_config_trashcan_pricing_per_subscription: 'За подписку',
  device_initial_config_trashcan_placement: 'Размещение',
  device_initial_config_trashcan_placement_on_the_street: 'На улице',
  device_initial_config_trashcan_placement_inside: 'Внутри',
  device_initial_config_trashcan_placement_backyard: 'Двор',
  device_initial_config_trashcan_customer_community_id: 'ID сообщества клиентов',
  device_initial_config_trash_truck_brand: 'Бренд',
  device_initial_config_trash_truck_plate_number: 'Номерной знак',
  device_initial_config_trash_truck_model: 'Модель',
  device_initial_config_find_encryption_key_by_device_number:
    'Найти шифровальный ключ по номеру устройства',

  sensor_config_header: 'Конфигурация Датчика',
  sensor_config_name: 'Название',
  sensor_config_sensor_name: 'Имя Датчика',
  sensor_config_sensor_icon: 'Имя значка',
  sensor_config_description: 'Описание',
  sensor_config_model: 'Модель',
  sensor_config_serial_number: 'Серийный Номер',
  sensor_config_manufacturer: 'Производитель',
  sensor_config_diameter: 'Диаметр',
  sensor_config_price: 'Цена',
  sensor_config_currency: 'Валюта',
  sensor_config_supported_visualization_types: 'Поддерживаемые типы визуализации',
  sensor_config_port_type: 'Тип Порта',
  sensor_config_port_type_digital_input_port: 'Цифровой Входной Порт',
  sensor_config_port_type_analog_input_port: 'Аналоговый Входной Порт',
  sensor_config_port_type_pulse_s0_input_port: 'Импульсный Входной Порт S0',
  sensor_config_port_type_pulse_input_port: 'Импульсный Входной Порт',
  sensor_config_port_type_on_off_input_port: 'Вкл. Выкл. Входной Порт',
  sensor_config_port_type_on_off_output_port: 'Вкл. Выкл. Выходной Порт',
  sensor_config_port_conversion_formula: 'Формула Преобразования Порта',
  sensor_config_formula: 'Формула',
  sensor_config_offset: 'Компенсировать',
  sensor_config_sensor_index_tooltip: 'Индекс датчика: {{sensor_index}}',
  sensor_config_visible: 'Видимость',
  sensor_config_order_number: 'Номер заказа',
  sensor_config_visible_true: 'Видимый',
  sensor_config_visible_false: 'Невидимый',
  sensor_config_use_in_sensor_aggregation: 'Использование в агрегации датчиков',
  sensor_config_use_in_sensor_aggregation_true: 'Использовать',
  sensor_config_use_in_sensor_aggregation_false: 'Не использовать',
  sensor_config_value_labels: 'Метки значений',
  sensor_config_label_for_value_zero: 'Метка для значения "0"',
  sensor_config_label_for_value_one: 'Метка для значения "1"',
  sensor_config_inverted_read_state_value: 'Инвертированное Чтение',
  sensor_config_inverted_read_state_value_true: 'Инвертировано',
  sensor_config_inverted_read_state_value_false: 'Неинвертировано',
  sensor_config_register_address: 'Адрес регистра',
  sensor_config_data_type: 'Тип данных',
  sensor_config_count: 'Количество',
  sensor_config_number_registers: 'Количество регистров',
  sensor_config_particle_size: 'Размер частицы',
  sensor_config_power: 'Мощность',
  sensor_config_measurement_type: 'Тип измерения',
  sensor_config_measurement_group: 'Группа измерений',
  tasmota_generic_digital_sensor: 'Tasmota общий цифровой датчик',
  tasmota_alarm_input_sensor: 'Tasmota датчик входа тревоги',
  tasmota_generic_analog_sensor: 'Tasmota общий аналоговый датчик',

  device_counter_statistics_statistics_id: 'Статистика, id: {{device_number}}, {{description}}',
  device_counter_statistics_quarter: 'Квартал',
  device_counter_statistics_flow: 'Поток',
  device_counter_statistics_hour: 'Час',
  device_counter_statistics_quantity: 'Количество',
  device_counter_statistics_value: 'Стоимость',
  device_counter_statistics_digital_ports_must_be_present:
    'Чтобы увидеть эту таблицу, вам необходимо подключить импульсный вход к датчику водомера.',
  device_counter_statistics_name_must_have_initialized_value:
    'Параметры Q3, R и Диаметр требуются для импульсного входа, подключенного к датчику водомера.',

  company_manager_title: 'Создать или удалить аккаунт: {{company_name}}',
  company_manager_account_name: 'Имя Учетной Записи',
  company_manager_solution: 'Тип проекта',
  company_manager_solution_option_none: 'Неназначенный',
  company_manager_solution_option_agri: 'Аграрный',
  company_manager_solution_option_air_quality: 'Чистый воздух',
  company_manager_solution_option_street_lights: 'Уличное освещение',
  company_manager_solution_option_pump_station: 'Насосная станция',
  company_manager_solution_option_smart_waste: 'Умные отходы',
  company_manager_solution_option_level: 'Мониторинг уровня',
  company_manager_solution_option_gas: 'Мониторинг газа',
  company_manager_solution_option_pressure: 'Мониторинг давления',
  company_manager_solution_option_smart_water: 'Умная вода',
  company_manager_solution_option_environment_monitoring: 'Мониторинг окружающей среды',
  company_manager_solution_option_energy: 'Мониторинг энергии',
  company_manager_license: 'Лицензия',
  company_manager_account: 'Аккаунт',
  company_manager_create_company: 'Создать компанию',
  company_manager_create_company_error: 'Произошла проблема при создании вашей компании',
  company_manager_license_info_box:
    'Приложение лицензии требует действительный идентификатор учетной записи. Проверьте идентификатор вашей учетной записи дважды, если хотите включить его в процесс создания.',
  company_manager_valid_from: 'Действительно с',
  company_manager_valid_to: 'Действительно до',
  company_manager_solution_type: 'Тип решения',
  company_manager_contact_id: 'Идентификационный номер контакта',
  company_manager_account_id: 'Идентификатор аккаунта',
  company_manager_license_type: 'Тип лицензии',
  company_manager_timezone: 'Часовой пояс',
  company_manager_country: 'Страна',
  company_manager_countries_error: 'Не удалось загрузить страны',
  company_manager_timezones_error: 'Не удалось загрузить часовые пояса',
  company_manager_account_info: 'Информация об аккаунте',
  company_manager_address: 'Адрес',
  company_manager_city: 'Город',
  company_manager_municipality: 'Муниципалитет',
  company_manager_area: 'Район',
  company_manager_zip_code: 'Почтовый индекс',
  company_manager_vat_number: 'Идентификационный номер НДС',
  company_manager_account_ext_number: 'Внешний номер аккаунта',
  company_manager_account_ext_type: 'Внешний тип аккаунта',
  company_manager_account_ext_type_none: 'Нет',
  company_manager_account_ext_type_household: 'Домохозяйство',
  company_manager_account_ext_type_business: 'Бизнес',

  company_manager_license_per_device: 'На устройство',
  company_manager_license_per_reading: 'На отчет',
  company_manager_license_per_sensor: 'На датчик',
  company_manager_license_per_poc: 'На доказательство концепции (POC)',
  company_manager_license_per_remote_node: 'На удаленный узел',

  company_manager_creating_account: 'Создание аккаунта: {{company_name}}',
  company_manager_deleting_account: 'Удаление аккаунта: {{company_name}}',
  company_manager_account_created: 'Аккаунт создан успешно',
  company_manager_account_deleted: 'Аккаунт удален успешно',

  company_manager_update_company: 'Обновить компанию',
  company_manager_delete_company: 'Удалить компанию',
  company_manager_actions: 'Действия',
  company_manager_delete_modal_description:
    'Вы уверены, что хотите удалить эту компанию? Действие необратимо.',
  company_manager_confirm_button: 'Подтвердить',
  company_manager_cancel_button: 'Отменить',
  company_manager_delete_company_error_message: 'Произошла ошибка при удалении компании',
  company_manager_update_btn: 'Обновить',
  company_manager_child_company_warning_message: 'Создание дочерней компании',
  company_manager_current_logged_in_company: 'компания, в которую вы в настоящее время вошли',
  company_manager_current_selected_company: 'компания, которую вы в настоящее время выбрали',
  accounts_child_companies: 'Дочерние аккаунты',
  accounts_contactRef: 'Идентификатор контакта',
  accounts_externalNumber: 'Внешний номер',
  accounts_accountRef: 'Идентификатор аккаунта',
  accounts_logo: 'Логотип',
  accounts_info_unavailable: 'Для этого аккаунта нет информации о компании.',
  company_manager_accountRef_is_disabled_because_of_license_type:
    'Идентификатор аккаунта отключен из-за лицензии на POC',
  accounts_none: 'Нет',
  company_manager_update_company_success: 'Компания успешно обновлена',
  company_manager_update_company_error: 'Произошла ошибка при обновлении компании',
  company_manager_account_name_exists: 'Аккаунт с таким именем уже существует.',

  license_manager_title: 'Обновить лицензию: {{company_name}}',
  license_manager_license: 'Лицензия',
  license_manager_license_updated: 'Лицензия обновлена',

  companies_title: 'Количество счетов: {{company_number}}',
  companies_table_name: 'Название',
  companies_number_of_accounts: 'Количество аккаунтов:',
  companies_search: 'Поиск',

  users_title: 'Пользователи',
  units_type: 'Тип Единиц',

  reports_export_format_type: 'Формат',

  login_form_forgot_password: 'Забыл пароль?',

  pump_auto_every: 'Auto every {{secs}} secs',
  pump_svg_last_updated: 'Last updated: {{timestamp}}',
  pump_svg_power_supply: 'Power Supply',
  pump_svg_water_level_controller: 'Water Level Controller',
  pump_svg_pump: 'Pump',
  pump_svg_level_sensor: 'Level Sensor',
  pump_svg_pump_on_sensor: 'Pump-on Sensor',
  pump_svg_pump_off_sensor: 'Pump-off Sensor',
  pump_svg_dry_run_sensor: 'Dry Run Sensor',

  device_groups_error_please_select_company: 'Пожалуйста, выберите компанию.',

  device_groups_btn_add: 'Добавлять',
  device_groups_btn_edit: 'Редактировать',
  device_groups_btn_delete: 'Удалить',
  device_groups_btn_cancel: 'Отмена',
  device_groups_tooltip_edit: 'Редактировать',
  device_groups_tooltip_delete: 'Удалить',
  device_groups_color_picker_label: 'Цвет группы устройств',

  device_groups_name: 'Имя',
  device_groups_devices: 'Устройства',
  device_groups_view_devices: 'Посмотреть {{count}} устройств',
  device_groups_group_name: 'Имя группы',
  device_groups_parent_device_group: 'Родительская группа устройств',
  device_groups_auto_device_group_type_label: 'Автоматическая группа устройств',
  device_groups_auto_device_group_type_none: 'Без автоматической группы',
  device_groups_auto_device_group_type_all_devices: 'Все устройства',
  device_groups_auto_device_group_type_all_water: 'Все водяные устройства',
  device_groups_auto_device_group_type_all_energy: 'Все энергетические устройства',
  device_groups_auto_device_group_type_all_pressure: 'Все датчики давления',
  device_groups_auto_device_group_type_all_barometric_pressure:
    'Все датчики барометрического давления',
  device_groups_auto_device_group_type_all_levels: 'Все датчики уровня',
  device_groups_auto_device_group_type_all_soil_moisture: 'Все датчики влажности почвы',
  device_groups_auto_device_group_type_all_air_humidity: 'Все датчики влажности воздуха',
  device_groups_auto_device_group_type_all_temperatures: 'Все датчики температуры',
  device_groups_auto_device_group_type_all_pm10: 'Все датчики PM10',
  device_groups_auto_device_group_type_all_pm2_5: 'Все датчики PM2.5',
  device_groups_auto_device_group_type_unknown: 'Неизвестная автоматическая группа',
  device_groups_auto_device_group_alert_title: 'Автоматическая группа устройств включена',
  device_groups_auto_device_group_alert_description: 'Эта группа настроена как {{type}}.',
  device_groups_auto_device_group_change: 'Изменить',
  device_groups_auto_device_group_change_modal_title: 'Изменить автоматическую группу устройств',
  device_groups_menuitem_none: 'Никто',
  device_groups_add_device_group: 'Добавить группу устройств',
  device_groups_edit_device_group: 'Изменить группу устройств',
  device_groups_delete_device_group: 'Удалить группу устройств',

  device_grous_add_sensor_device: 'Добавление датчика и устройства в группу',

  device_groups_table_sensor_group_name_header: 'Имя группы датчиков',
  device_groups_table_parent_group_name_header: 'Имя родительской группы',
  device_groups_table_device_count_header: 'Количество устройств',

  device_groups_sensor_table_device_number_header: 'Номер устройства',
  device_groups_sensor_table_sensor_name_header: 'Имя датчика',
  device_groups_sensor_table_sensor_index_header: 'Индекс датчика',
  device_groups_sensor_table_select_message: 'Выбор группы датчиков',

  device_groups_sensors_add_modal_device_placeholder: 'Номер устройства',
  device_groups_sensors_add_modal_sensor_placeholder: 'Датчик',
  device_groups_sensors_add_modal_device_group_name_required: 'Укажите название группы устройств',

  device_groups_sensors_delete_description:
    'Удаление этой конфигурации приведет к необратимому удалению ее с сервера.',
  device_groups_device_group_delete_description:
    'Удаление группы устройств приведет к необратимому удалению ее с сервера.',

  device_groups_select_company_header: 'Выберите компанию для продолжения',
  device_groups_select_company_from: 'Отсюда: ',
  device_groups_select_company_accounts_page_link: 'Страница аккаунтов',

  device_groups_create_device_group_error: 'Произошла ошибка при создании новой группы устройств',
  device_groups_update_device_group_error: 'Произошла ошибка при обновлении группы устройств',
  device_groups_delete_device_group_error: 'Произошла ошибка при удалении группы устройств',
  device_groups_add_device_sensor_device_group_error: 'Произошла ошибка при добавлении датчика',
  device_groups_remove_device_sensor_device_group_error: 'Произошла ошибка при удалении датчика',

  /*
   * |==============|
   * | Users Config |
   * |==============|
   */

  //Page
  users_header: 'Пользователи',
  users_table_username: 'Имя пользователя',
  users_table_first_name: 'Имя',
  users_table_last_name: 'Фамилия',
  users_table_company_name: 'Счет',
  users_table_email: 'Электронная почта',

  //Filters
  users_filter_username: 'Имя пользователя фильтра',
  users_filter_first_name: 'Фильтровать имя',
  users_filter_last_name: 'Фильтровать фамилию',
  users_filter_email: 'Фильтр электронной почты',
  users_filter_company_name: 'Фильтровать учетную запись',
  users_reset_filter_icon: 'Сброс фильтров',
  users_table_is_contact_person: 'Контактное лицо',

  //Modals
  users_add_modal_header: 'Добавить пользователя',
  users_update_modal_header: 'Обновить пользователя',
  user_remove_modal_icon: 'Удалить пользователя',
  users_remove_modal_header: 'Вы уверены, что хотите удалить пользователя {{username}}?',
  users_remove_modal_body:
    'Нажатие кнопки Удалить приведет к окончательному удалению выбранного пользователя с сервера.',
  users_is_dashboard_enabled: 'Включить панель управления',
  users_is_contact_person: 'Контактное лицо',

  //Errors
  users_password_match: 'Пароли не совпадают',
  users_email_blank: 'Электронная почта не может быть пустой',
  users_load_error: 'Не удалось загрузить пользователей',
  users_update_error: 'Произошла ошибка при обновлении пользователя',
  users_delete_error: 'Не удалось удалить пользователя',
  users_create_error: 'Не удалось создать пользователя',

  // Success
  users_update_success: 'Пользователь успешно обновлен',
  users_delete_success: 'Пользователь успешно удален',
  users_create_success: 'Пользователь успешно создан',
  /*
   * |=====================|
   * | Value Ranges Config |
   * |=====================|
   */

  // Buttons & tooltips
  value_ranges_btn_add: 'Добавлять',
  value_ranges_btn_defaults: 'По умолчанию',
  value_ranges_line_color: 'Цвет линии',
  value_ranges_node_color: 'Цвет узла',
  value_ranges_foreground_color: 'Цвет переднего плана',
  value_ranges_background_color: 'Фоновый цвет',
  value_ranges_loading: 'Загрузка...',
  value_ranges_nothing_to_show: 'Нет данных для отображения',

  //Page
  value_ranges_header: 'События диапазона значений',
  value_ranges_trigger: 'Вызвать',
  value_ranges_notifications: 'Уведомления',
  value_ranges_before: 'До',
  value_ranges_after: 'После',
  value_ranges_disabled: 'Выключен',
  value_ranges_date_range: 'Диапазон дат',
  value_ranges_daily_time_slot: 'Ежедневный интервал',
  value_ranges_timezone: 'Часовой пояс',

  //Modals
  value_ranges_add_event: 'Добавить событие',
  value_ranges_edit_event: 'Редактировать событие',
  value_ranges_add_default_events: 'Добавить события по умолчанию',
  value_ranges_remove_modal_header: 'Вы уверены, что хотите удалить диапазон значений',
  value_ranges_remove_modal_body: 'Нажатие «Удалить» навсегда удалит выбранный диапазон значений.',

  //Form
  value_range_form_name: 'Название события',
  value_range_form_function: 'Функция',
  value_range_form_sensor: 'Датчик',
  value_range_form_description: 'Описание',
  value_range_form_min: 'Min',
  value_range_form_max: 'Max',
  value_range_form_severity: 'Тяжесть',
  value_range_form_start_day: 'День начала',
  value_range_form_start_month: 'Месяц начала',
  value_range_form_start_time: 'Время начала',
  value_range_form_end_day: 'Конец дня',
  value_range_form_end_month: 'Конец месяца',
  value_range_form_end_time: 'Время окончания',
  value_range_form_enable_events: 'Включить события?',
  value_range_form_select_color: 'Выбранный цвет',
  value_range_form_notification_email: 'Электронная почта',
  value_range_form_notification_push_notification: 'Отправить уведомление',
  value_range_form_notification_sms: 'SMS',
  value_range_form_notification_push: 'Отправить уведомление',
  value_range_form_notification_call: 'Вызов',
  value_range_form_line_custom_color: 'Пользовательский цвет линии',
  value_range_form_marker_custom_color: 'Пользовательский цвет маркера',
  value_range_form_no_notifications: 'Нет уведомлений',

  //Errors
  value_range_tooltip_severity:
    'Тяжести, превышающие 7, считаются серьезными. Серьезные события обозначаются восклицательным знаком.',
  value_range_error_add: 'Не удалось добавить событие',
  value_range_error_edit: 'Не удалось отредактировать мероприятие',
  value_range_name_is_required: 'Укажите имя',
  value_range_name_already_exists:
    'Название события уже существует для этого устройства и датчика.',
  value_range_name_incorect_time: 'Неверный формат времени',
  value_range_min_greater_than_max: 'Мин. не может быть больше макс.',
  value_range_min_equal_to_max: 'Мин не может быть равен макс',
  value_range_min_max_is_required: 'Требуется мин. или макс.',
  value_range_error_occured: 'Произошла ошибка',
  value_range_start_incorrect_time:
    'Время начала имеет неверный формат. Должно быть ЧЧ:мм. Правильно: 01:00. Неправильно: 1:00.',
  value_range_end_incorrect_time:
    'Время окончания имеет неверный формат. Должно быть ЧЧ:мм. Правильно: 01:00. Неправильно: 1:00.',
  value_range_start_day_missing_start_month: 'День начала должен иметь месяц начала',
  value_range_end_day_missing_end_month: 'Конечный день должен иметь конечный месяц',
  value_range_start_month_missing_start_day: 'Месяц начала должен иметь день начала',
  value_range_end_month_missing_end_day: 'Конечный месяц должен иметь день окончания',
  value_range_mixed_alphabets_error:
    'Обнаружено использование смешанных алфавитов, используйте только один язык',

  /*
   * |==========|
   * | Commands |
   * |==========|
   */

  // Command State
  commands_command_state_pending: 'В ожидании',
  commands_command_state_sent: 'Отправлено',
  commands_command_state_cancelled: 'Отменено',
  commands_command_state_status_ok: 'ОК',
  commands_command_state_status_nok: 'Не ОК',
  commands_command_state_unknown: 'Неизвестно',
  commands_command_state_timeout: 'Время ожидания истекло',

  // Command Type
  commands_command_type_relay_switch: 'Релейный переключатель',
  commands_command_type_single_relay_switch: 'Одиночный релейный переключатель',
  commands_command_type_relay_switch_with_delay: 'Релейный переключатель с задержкой',
  commands_command_type_relay_statuses: 'Статусы реле',
  commands_command_type_send_config_over_mqtt: 'Отправка конфигурации по MQTT',
  commands_command_type_send_date_over_mqtt: 'Отправить дату по MQTT',
  commands_command_type_modbus: 'Modbus',
  commands_command_type_tasmota_relay_switch: 'Команда реле Tasmota',
  commands_command_type_reset: 'Сброс',
  commands_command_type_scheduled_relay_command: 'Запланированная команда реле',
  commands_command_type_scheduled_relay_command_4: 'Запланированные команды реле (4)',

  // Errors
  commands_error_missing_device_number: 'Device Number missing or wrong.',

  // Buttons
  commands_btn_send_command: 'Send Command',
  commands_btn_refresh: 'Oбновить',
  commands_btn_submit: 'Submit',

  // Tooltips
  commands_tooltip_edit: 'Edit',

  // Popups
  commands_send_command: 'Send Command',
  commands_edit_command: 'Edit Command',
  commands_command_type: 'Command Type',
  commands_parameters: 'Parameters',
  commands_parameter_name: 'Parameter Name',
  commands_parameter_value: 'Parameter Value',

  // Page
  commands_header: 'Commands',
  commands_type: 'Type',
  commands_status: 'Status',
  commands_relay_1_status: 'Relay 1 Status',
  commands_relay_2_status: 'Relay 2 Status',
  commands_created: 'Created',
  commands_sent: 'Sent',
  commands_executed: 'Executed',
  commands_relay_status: 'Статус реле',
  commands_relay_index: 'Индекс реле',

  commands_sensor_index: 'Индекс датчика',
  commands_slave_device_number: 'Номер подчинённого устройства',
  commands_hour: 'Час',
  commands_minutes: 'Минуты',
  commands_auto_refresh: 'Автообновление',
  commands_no_commands: 'На это устройство ещё не отправлялись команды.',
  commands_no_parameters: 'Эта команда не принимает параметров.',
  commands_no_parameter_values: 'Для этого устройства нет доступных значений.',
  commands_schedule_group: 'Расписание {{index}}',
  commands_cancel_command: 'Отменить команду',
  commands_cancel_command_confirm:
    'Эта команда ещё не отправлена. Её отмена не позволит доставить её на устройство.',
  commands_cancel_command_success: 'Команда отменена',
  commands_send_command_success: 'Команда отправлена',
  commands_btn_close: 'Закрыть',
  commands_btn_keep: 'Оставить',
  commands_parameters_empty: 'Без параметров',
  commands_command_id: 'ID',
  commands_error_send_failed: 'Не удалось отправить команду.',
  commands_error_cancel_failed: 'Не удалось отменить команду.',
  commands_error_parameters_failed: 'Не удалось загрузить параметры этой команды.',
  commands_only_pending_can_be_cancelled: 'Отменить можно только ожидающие команды.',
  commands_last_updated: 'Обновлено в {{time}}',
  commands_error_list_failed: 'Не удалось загрузить команды.',
  commands_range_hint: 'Допустимо: {{min}}–{{max}}',

  /*
   * |=============|
   * | Copy Config |
   * |=============|
   */

  // Page
  copy_config_copy_config: 'Копировать Конфигурацию',
  copy_config_to_device_number_with_name_absent: 'На устройство: {{device_number}}',
  copy_config_to_device_number_with_name_present:
    'На устройство: {{device_name}} ({{device_number}})',
  copy_config_from_device_number: 'С Номера Устройства',
  copy_config_copy_config_type_label: 'Тип копирования конфигурации',
  copy_config_existing_device_option: 'Существующее устройство',
  copy_config_new_device_option: 'Новое устройство',
  copy_config_should_copy_label: 'Следует копировать:',
  copy_config_should_copy_config_option: 'Конфигурация',
  copy_config_should_copy_value_ranges_option: 'Диапазоны значений',

  // Buttons
  copy_config_btn_copy: 'Копировать',

  //Toast
  copy_config_toast_copied_success: 'Конфигурация устройства успешно скопирована.',
  copy_config_toast_copied_error:
    'Произошла ошибка при попытке скопировать конфигурацию устройства.',
  copy_config_value_ranges_toast_copied_success: 'Диапазоны значений успешно скопированы.',
  copy_config_value_ranges_toast_copied_error:
    'Произошла ошибка при попытке скопировать диапазоны значений.',

  /*
   * |============|
   * | Statistics |
   * |============|
   */
  statistics_header: 'Статистика',
  statistics_header_hours: 'Часы',
  statistics_header_quantity: 'Количество',
  statistics_header_value: 'Стоимость',
  statistics_quantity_minimum: 'Минимум',
  statistics_quantity_maximum: 'Максимум',
  statistics_quantity_average: 'Средний',
  statistics_quantity_total: 'Всего',
  statistics_quantity_hours: 'Часы',
  statistics_quantity_counters: 'Счетчики',
  statistics_error_title: 'Статистика недоступна',
  statistics_error_missing_config_title: 'Конфигурация водомера неполная',
  statistics_error_missing_config_description:
    'Чтобы рассчитать статистику, для каждого водомера должны быть заданы diameter, q3 и r. Проверьте текущие значения ниже и заполните отсутствующие.',
  statistics_error_missing_field: 'Отсутствует {{field}}',
  statistics_error_not_defined: 'Не задано',
  statistics_error_open_sensor_config: 'Открыть конфигурацию датчика',
  statistics_error_update_values_hint:
    'Заполните отсутствующие значения и вернитесь на эту страницу.',
  statistics_error_contact_admin:
    'Пожалуйста, свяжитесь с администратором и попросите его задать отсутствующие значения конфигурации водомера.',
  statistics_error_flow_unit_not_configured: 'Для выбранного датчика не настроена единица расхода.',

  // Error
  statistics_error_definition_for_q3:
    'Датчик {{name}} содержит определение для q3. Пожалуйста, посетите страницу конфигурации датчика.',
  statistics_eror_definition_for_diameter:
    'Датчик {{name}} содержит определение диаметра. Пожалуйста, посетите страницу конфигурации датчика.',
  statistics_error_definition_for_r:
    'Датчик {{name}} содержит определение для r. Пожалуйста, посетите страницу конфигурации датчика.',
  statistics_error_no_water_meters_found:
    'Счетчики воды не найдены. Пожалуйста, посетите страницу конфигурации устройства.',

  /*
   * |=====|
   * | Map |
   * |=====|
   */
  map_add_device: 'Добавить  {{device}}',
  map_edit_device: 'Редактировать {{device}}',
  map_lat: 'Широта',
  map_long: 'Долгота',
  map_coordinates: 'Координаты',
  map_polygon: 'Полигон',
  map_linked_in_polygons: 'Содержится в полигонах:',
  map_loading: 'Загрузка...',

  // Button
  map_btn_link_device: 'Связать устройство',
  map_btn_submit: 'Подавать',

  // Error
  map_err_add_device_to_map: 'Не удалось добавить устройство на карту.',
  map_err_change_location: 'Не удалось изменить местоположение.',
  map_err_link_polygon: 'Не удалось установить связь с полигоном.',

  // Device Modal
  map_btn_get_curr_location: 'Получить текущее местоположение',
  map_geolocation_not_supported: 'Геолокация не поддерживается вашим браузером',
  map_lat_validation_message: 'Неверная широта',
  map_long_validation_message: 'Неверная долгота',
  map_invalid_location: 'Недопустимое местоположение',
  map_invalid_coordinate_input:
    'Неверный ввод координат. Это должно быть «широта, долгота», например. 42.123, 23.123',

  // Set Coordinates Modal
  map_coordinates_modal_btn_label: 'Установить Координаты',
  map_coordinates_modal_title: 'Установить Координаты',
  map_coordinates_modal_target_option_self: 'Для Себя',
  map_coordinates_modal_target_option_company: 'Для Компании',
  map_coordinates_modal_target_option_user: 'Для Пользователя',
  map_coordinates_modal_select_user_autocomplete_label: 'Имя пользователя',
  map_coordinates_modal_save_for_self_warning_message:
    'Сохранение установит текущие координаты в качестве параметров по умолчанию для вашего текущего пользователя. Вы уверены, что хотите продолжить?',
  map_coordinates_modal_save_for_company_warning_message:
    'Сохранение установит текущие координаты в качестве параметров по умолчанию для каждого пользователя в вашей компании. Вы уверены, что хотите продолжить?',
  map_coordinates_modal_save_for_user_warning_message:
    'Сохранение установит текущие координаты в качестве параметров по умолчанию для выбранного пользователя. Вы уверены, что хотите продолжить?',
  map_coordinates_modal_confirm_btn_label: 'Подтвердить',
  map_coordinates_modal_cancel_btn_label: 'Отмена',

  /*
   * |===============|
   * | Sensor Config |
   * |===============|
   */

  flow_time_units: 'Единица времени',
  flow_measurement_units: 'Единица измерение',
  flow_configuration_label: 'Конфигурация потока',
  flow_coefficient: 'Коэффициент',
  sensor_config_sensor_group_name: 'Название группы датчиков',
  flow_configuration_alert_message: 'Проверьте следующие конфигурации потока:\n{{message}}',
  flow_configuration_invalid_sensor_row_message:
    'Индекс: {{sensor_index}} с именем: {{sensor_name}}\n',
  flow_configuration_sensor_name_not_set_label: 'Не установлено',

  /*
   * |===================|
   * | Device Prediction |
   * |===================|
   */
  device_prediction: 'Прогнозирование устройств',
  device_prediction_header: 'Анализ временных рядов',
  device_prediction_sensor_name: 'Имя Датчика',
  device_prediction_forward_days: 'Дни вперед',
  device_prediction_backward_days: 'Дни обратного хода',
  device_prediction_generate_btn: 'Генерировать',
  device_prediction_error: 'Ошибка',
  device_prediction_error_msg_json: 'Возникла проблема с созданием прогнозных данных.',
  device_prediction_error_msg_image: 'Возникла проблема с созданием прогнозного изображения.',
  device_prediction_date: 'Дата',
  device_prediction_trend: 'Тренд',
  device_prediction_time: 'Время',
  device_prediction_legend_prediction: 'Прогноз',
  device_prediction_legend_range: 'Диапазон прогноза',
  device_prediction_legend_consumption: 'Текущее потребление',
  device_prediction_help_title: 'Помощь',
  device_prediction_help_title_input_guide: 'Руководство по вводу',
  device_prediction_help_input_guide_text:
    '<strong> 1. Период </strong> - Пользователи могут выбрать диапазон дат из предопределенных вариантов или установить пользовательский диапазон. Система анализирует данные внутри выбранного периода для расчета будущих прогнозов, предоставляя ценные инсайты. <br> <strong> 2. Имя сенсора </strong> – выберите сенсор, для которого вы хотите увидеть будущие прогнозы. <br> <strong> 3. Каждые </strong> - используется для более детальных прогнозов в терминах гранулярности времени. <br> <strong> 4. Дни вперед </strong> - количество дней, на которые пользователь хочет сделать прогноз в будущем. Эти прогнозы расширяются за пределы выбранного периода, предоставляя представление о предполагаемом поведении потребления. <br> <strong> 5. Дни назад </strong> - представляет количество дней, которые будут отображаться на графике и в таблице, начиная с последнего дня выбранного периода. Это показывает исторические реальные данные, полученные от устройства в течение указанного периода. <br> <strong> 6. Кнопка "Сгенерировать" </strong> – при нажатии "Сгенерировать", система расчитывает расход на основе выбранных настроек и генерирует прогнозы. Результаты затем отображаются как в Виде Графика, так и в Виде Таблицы. <br> <strong> 7. График </strong> – График отображает как дни вперед, так и дни назад, представляя реально полученные данные и показывая предсказанные данные. <br> <strong> 8. Таблица </strong> - Таблица показывает все данные от "от периода" до конца "дней вперед". Каждая строка включает конкретную дату, время и соответствующее значение тренда, указывающее общее направление или паттерн данных в течение времени. Это помогает понять, увеличиваются ли значения, уменьшаются ли они или остаются стабильными в течение предсказанного периода.',
  device_prediction_help_title_legend: 'Легенда',
  device_prediction_help_black:
    '<strong> Черный цвет </strong> - представляет реальные данные потребления в течение выбранного периода (пример: с 1 июля по 31 июля).',
  device_prediction_help_red:
    '<strong> Красный цвет </strong> - Представляет реальное потребление, если есть данные вне выбранного периода. На изображении выше есть реальные данные, полученные от устройства в дни, на которые модель настроена на прогнозирование. Пользователь может сравнить предсказанные значения (темно-синий) с красными (реальные данные).',
  device_prediction_help_dark_blue:
    ' <strong> Темно-синий цвет </strong> - представляет прогноз для выбранного периода, который включает в себя старые данные и расширяется в будущее с предсказанными значениями для дней вперед. Эти предсказанные значения предоставляют представление о предполагаемой тенденции потребления.',
  device_prediction_help_light_blue:
    '<strong> Светло-синий цвет </strong> - представляет диапазон предсказанных значений. Он указывает, что фактические данные потребления могут находиться в этом диапазоне, что указывает на неопределенность, связанную с прогнозами.',
  device_prediction_help_example:
    "Если дата 'С' установлена на 1 июля, а дата 'ПО' на 31 июля, с 'Днями вперед' 30, 'Днями назад' 30 и 'КАЖДЫЕ' 10 минут, график будет отображать 30-дневное реальное потребление (с 1 июля по 1 августа) и предсказанные значения на 30 дней вперед (с 1 августа по 1 сентября). Таблица будет показывать реальное и предсказанное потребление для каждого интервала по 10 минут с 1 июля по 1 сентября 2023 года.",

  /*
   * |=================|
   * | Counters Export |
   * |=================|
   */

  // Buttons and dropdowns
  counters_export_header: 'Отчет',
  counters_readings_header: 'Отчеты',
  counters_export_search: 'Поиск',
  counters_export_download: 'Скачать',
  counters_export_format: 'Формат',

  // Table columns
  counters_export_table_device_name: 'Имя устройства',
  counters_export_table_device_number: 'Номер устройства',
  counters_export_table_sensor_index: 'Индекс датчика',
  counters_export_table_sensor_name: 'Название датчика',
  counters_export_table_date: 'Дата',
  counters_export_table_counters: 'Значение',
  counters_export_table_prev_counters: 'Предыдущее значение',
  counters_export_table_dt: 'Разница по времени',
  counters_export_table_delta: 'Разница',
  counters_export_error_alert_message: 'Произошла ошибка при формировании данных.',
  counter_export_select_devices_label: 'Выберите устройства',
  counter_export_select_sensors_label: 'Выберите датчики',
  counter_export_sensor_index: 'Индекс датчика: {{sensor_index}}',

  counters_export_maximum_capacity_error_message: 'Достигнута максимальная экспортная мощность!',
  counters_export_maximum_capacity_suggestion_message:
    'Пожалуйста, уменьшите количество выбранных устройств или период даты.',
  counters_export_empty_selection_title: 'Выберите, что экспортировать',
  counters_export_empty_selection_message:
    'Выберите одно или несколько устройств или групп устройств, чтобы подготовить экспорт показаний.',
  counters_export_ready_title: 'Выбор готов',
  counters_export_ready_message:
    'Выбрано {{devicesCount}} устройств и {{groupsCount}} групп устройств. Нажмите Поиск для предварительного просмотра данных или Скачать для экспорта.',
  counters_export_selected_device_toast: 'Выбранное устройство: {{deviceNumber}}',
  /*
   * |====================|
   * | Consumption Export |
   * |====================|
   */

  // Buttons and dropdowns
  consumption_export_header: 'Экспорт данных',
  consumption_export_search: 'Поиск',
  consumption_export_download: 'Скачать',
  consumption_export_format: 'Формат',
  consumption_export_aggregation_period: 'Период агрегации',
  consumption_export_aggregation_options_none: 'Нет',
  consumption_export_aggregation_options_daily: 'Ежедневно',
  consumption_export_aggregation_options_weekly: 'Еженедельно',
  consumption_export_aggregation_options_monthly: 'Ежемесячно',
  consumption_export_aggregation_options_yearly: 'Ежегодно',

  // Table columns
  consumption_export_table_device_number: 'Номер устройства',
  consumption_export_table_sensor_index: 'Индекс датчика',
  consumption_export_table_address: 'Адрес',
  consumption_export_table_sensor_name: 'Название датчика',
  consumption_export_table_first_reading_date: 'Дата первого значения',
  consumption_export_table_first_reading_value: 'Первое значение',
  consumption_export_table_last_reading_date: 'Дата последнего значения',
  consumption_export_table_last_reading_value: 'Последнее значение',
  consumption_export_table_delta: 'Разница',
  consumption_export_table_average: 'Среднее',
  consumption_export_table_consumption_for_period: 'Потребление за период',
  consumption_export_empty_selection_title: 'Выберите, что экспортировать',
  consumption_export_empty_selection_message:
    'Выберите одно или несколько устройств или групп устройств, чтобы подготовить экспорт потребления.',
  consumption_export_ready_title: 'Выбор готов',
  consumption_export_ready_message:
    'Выбрано {{devicesCount}} устройств и {{groupsCount}} групп устройств. Нажмите Поиск для предварительного просмотра данных или Скачать для экспорта.',
  consumption_export_selected_device_toast: 'Выбранное устройство: {{deviceNumber}}',

  /*
   * |=================|
   * | Alarms Export |
   * |=================|
   */

  // Buttons and dropdowns
  alarms_export_header: 'Сигналы тревоги',
  alarms_export_search: 'Поиск',
  alarms_export_refresh: 'Oбновить',
  alarms_export_download: 'Скачать',
  alarms_export_format: 'Формат',

  alarms_return_to_alarms: 'Вернуться к сигналам тревоги',
  alarms_redirect_to_graph: 'Перенаправить на график',

  // Table columns
  alarms_export_table_date: 'Дата',
  alarms_export_table_device_number: 'Номер устройства',
  alarms_export_table_device_name: 'Имя устройства',
  alarms_export_table_severity: 'Значимость',
  alarm_severity_tooltip: 'Важность: {{value}} из 10',
  alarm_severity_none_tooltip: 'Важность для этой аварии не указана',
  alarms_export_table_sensor_index: 'Индекс датчика',
  alarms_export_table_sensor_name: 'Название датчика',
  alarms_export_table_alarm_type: 'Тип',
  alarms_export_table_alarm_status: 'Статус',
  alarms_export_table_description: 'Описание',
  alarms_export_table_link_to_graph: 'Ссылка на график',
  alarms_export_chip_status_active: 'Активный',
  alarms_export_chip_status_inactive: 'Неактивный',
  alarms_export_switch_title_label: 'Автообновление',
  alarms_export_error_alert_message: 'Произошла ошибка при формировании данных.',
  alarms_export_select_company_alert_message:
    'Выберите компанию, прежде чем получать сигналы тревоги',
  alarms_export_select_device_or_company_alert_message:
    'Выберите устройство или компанию перед получением сигналов тревоги',
  alarms_export_error_too_big_query:
    'Извличането на хронологию от Супер администратор для всички устройства и твърде голяма заявка. Моля, изберите компанию.',

  /*
   * |================|
   * | Inventory page |
   * |================|
   */

  //table
  device_inventory_page_header: 'Инвентарь',
  device_inventory_column_header_search: 'Поиск...',
  device_inventory_description: 'Описание',
  device_inventory_device_name: 'Имя устройства',
  device_inventory_device_number: 'Номер устройства',
  device_inventory_hardware_version: 'Версия аппаратного обеспечения',
  device_inventory_model: 'Модель',
  device_inventory_software_version: 'Версия программного обеспечения',
  device_inventory_actions: 'Действия',
  nomenclature: 'Номенклатура',

  //modal
  device_inventory_manual: 'Ручной',
  device_inventory_template: 'Шаблон',
  device_inventory_add_device: 'Добавить устройство',
  device_inventory_create_device_button: 'Создать устройство',
  device_inventory_delete_unlink_modal_body:
    'Это навсегда удалит выбранное устройство или вы можете отключить его от выбранной компании. Устройство будет отключено от текущего аккаунта и всех субаккаунтов. Если вы хотите отключить устройство только от текущего аккаунта, перейдите на страницу "Подключить устройство".',
  device_inventory_delete_modal_body: 'Это навсегда удалит выбранное устройство.',
  device_inventory_hardware_version_helper: 'Требуемый формат: X.X.X, где X - число',
  device_inventory_update_device_button: 'Обновить устройство',
  device_inventory_update_device_title: 'Обновление {{number}}',
  device_inventory_modal_delete_device_title: 'Удалить устройство {{number}}',

  device_inventory_software_version_helper:
    'Требуемый формат: X.X.X или X.X.X-, X.X.X_ с последующими символами, где X - число',
  device_inventory_description_helper: 'Достигнут предел длины описания',
  device_inventory_device_number_helper:
    'Пожалуйста, введите 8 символов, содержащих только буквы (A-Z) и цифры (0-9).',
  device_inventory_modal_select_action: 'Select action for device {{deviceNumber}}',
  device_inventory_reference_device_number: 'Выберите устройство для ссылки',
  device_inventory_nomenclature_required_for_model: 'Номенклатура обязательна для {{model}}',

  //success
  device_inventory_create_device_success: 'Устройство успешно создано',
  device_inventory_update_device_success: 'Устройство успешно обновлено',
  device_inventory_delete_device_success: 'Устройство успешно удалено',
  device_inventory_unlink_device_success: 'Устройство успешно отвязано',
  device_inventory_rma_add_success: 'Запись RMA успешно добавлена',
  device_inventory_rma_history_title: 'История RMA - {{number}}',
  device_inventory_rma_add_record: 'Добавить запись',
  device_inventory_rma_no_records: 'Нет записей RMA для этого устройства',
  device_inventory_rma_add_error: 'Произошла ошибка при добавлении записи RMA',
  rma_record_date: 'Дата',
  rma_record_date_required: 'Дата обязательна',
  rma_record_type: 'Тип',
  rma_record_category: 'Категория',
  rma_record_comments: 'Комментарии',
  rma_record_save: 'Сохранить',
  rma_record_back: 'Назад',
  rma_type_INCIDENT: 'Инцидент',
  rma_type_DEVICE_EVENT: 'Событие устройства',
  rma_type_RMA: 'RMA',
  rma_category_BATTERY_REPLACEMENT: 'Замена батареи',
  rma_category_SIM_CARD_CHANGE: 'Замена SIM-карты',
  rma_category_ENCLOSURE_DEGRADATION: 'Износ корпуса',
  rma_category_FLOOD_DAMAGE: 'Повреждение от затопления',
  rma_category_ANTENNA_REPLACEMENT: 'Замена антенны',
  rma_category_POWER_SUPPLY_PROBLEM: 'Проблема с питанием',
  rma_category_PHYSICAL_DAMAGE: 'Физическое повреждение',
  rma_category_STOLEN: 'Украдено',
  rma_category_WRONG_CONFIGURATION: 'Неправильная конфигурация',
  rma_category_OTHER: 'Другое',

  //error
  device_inventory_create_device_error: 'Произошла ошибка при создании устройства',
  device_inventory_delete_device_error: 'Произошла ошибка при удалении устройства',
  device_inventory_device_exists: 'Устройство уже существует',
  device_inventory_empty_device_error: 'Номер устройства не может быть пустым',
  device_inventory_empty_reference_error: 'Выберите устройство для ссылки',
  device_inventory_empty_device_name_error: 'Имя устройства не может быть пустым',
  device_inventory_empty_hardware_error: 'Версия аппаратного обеспечения не может быть пустой',
  device_inventory_empty_software_error: 'Версия программного обеспечения не может быть пустой',
  device_inventory_error: 'Не удалось загрузить устройства',
  device_inventory_update_device_error: 'Произошла ошибка при обновлении устройства',
  device_inventory_already_exists_error: 'Устройство с таким номером уже существует',
  device_inventory_empty_nomenclature_error: 'Номенклатура не может быть пустой',
  device_inventory_empty_manufacturing_date_error: 'Дата производства не может быть пустой',
  device_inventory_empty_warranty_period_error: 'Гарантийный срок не может быть пустым',

  /*
   * |====================|
   * | Transmissions page |
   * |====================|
   */

  //page
  transmissions_page_title: 'Передачи',
  transmissions_page_refresh: 'Обновить',
  transmissions_page_export_csv: 'Экспорт в CSV',
  transmissions_page_error_message: 'Не удалось загрузить передачу',

  //table
  transmissions_table_device_number: 'Номер устройства',
  transmissions_table_device_name: 'Название устройства',
  transmissions_table_last_transmission: 'Последняя передача',
  transmissions_table_next_transmission: 'Следующая передача',
  transmissions_table_days: 'Дни',
  transmissions_table_transmission: 'Передача',
  transmissions_table_count: 'Количество',
  transmissions_table_customer: 'Клиент',
  transmissions_table_address: 'Адрес',
  transmissions_table_ok: 'OK',
  transmissions_table_devEUI: 'devEUI',
  transmissions_table_simcard_number: 'Номер сим-карты',
  transmissions_table_simcard_provider: 'Провайдер сим-карты',
  transmissions_table_apn: 'APN',

  /*
   * |===============|
   * | Device Config |
   * |===============|
   */

  // page
  device_config_period: 'Период',
  device_config_every: 'Все',

  // error
  device_config_error_record_period_postiive: 'Период записи должен быть положительным.',
  device_config_error_transmission_period_positive: 'Период передачи должен быть положительным.',
  device_config_error_record_must_be_greater_than_transmission:
    'Период записи не может быть больше периода передачи.',
  device_config_error_not_divisible: 'Период записи не делится на период передачи.',
  device_config_error_max_threshold_reached:
    '{{curr}} записей на передачу больше максимального {{max}}.',

  /*
   * |=======|
   * | Graph |
   * |=======|
   */
  graph_tabs_readings: 'Значения',
  graph_tabs_prediction: 'Прогноз',
  graph_tabs_average: 'Среднее',
  graph_tabs_previous: 'Предыдущий',
  graph_column_sensor: 'Датчик',
  graph_column_index: 'Индекс',
  graph_column_device: 'Устройство',
  graph_column_device_name: 'Название устройства',
  graph_column_date: 'Дата',
  graph_column_readings: 'Значение',
  graph_column_previous_readings: 'Предыдущее значение',
  graph_column_delta: 'Разница',
  /*
   * |===============|
   * | Settings page |
   * |===============|
   */
  settings_page_header: 'Настройки',
  settings_submit_success_msg: 'Настройки сохранены',
  settings_submit_error_msg: 'Настройки не удалось сохранить',
  settings_input_invalid_format_error_msg: 'Неверный формат данных',
  settings_certificate_not_found_error: 'По этому пути файла не найдено никаких сертификатов',
  settings_add_button: 'Добавить',
  settings_submit_button: 'Отправить',
  settings_input_key_label: 'Ключ',
  settings_input_type_label: 'Тип',
  settings_input_value_label: 'Значение',
  settings_select_type_string: 'Строка',
  settings_select_type_number: 'Число',
  settings_select_type_boolean: 'Булево',
  settings_select_type_object: 'Объект',
  settings_logo_label: 'Логотип',
  settings_dashboard_layout_label: 'Макет панели',
  settings_certificate_label: 'Путь к сертификату',
  settings_device_panel_title: 'Название панели устройства',
  settings_sensor_panel_title: 'Название панели датчика',
  settings_header_home_label: 'Заголовок Главная (Портал)',
  settings_header_dashboard_label: 'Заголовок Панели управления (Портал)',
  settings_footer_main_label: 'Основная метка в подвале (Портал)',
  settings_footer_link_label: 'Метка ссылки в подвале (Портал)',
  settings_footer_link_url: 'URL ссылки в подвале (Портал)',
  settings_alarm_notification_display_period:
    'Период отображения уведомлений об авариях (часы) (Портал)',

  /* |===========|
   * | New Graph |
   * |===========|
   */

  //page
  new_graph_add_device_group_modal_title: 'Конфигурация датчиков группы устройств "Каждый"',
  new_graph_add_device_group_modal_device_group: 'Группа устройств: ',
  new_graph_add_device_group_modal_sensors_to_add: 'Датчики для добавления: ',
  new_graph_add_device_group_modal_every_selector_mode_per_device: 'На устройство',
  new_graph_add_device_group_modal_every_selector_mode_per_sensor: 'На датчик',
  new_graph_add_device_group_modal_sensor_limit_message:
    'Вы не можете превысить лимит графика в {{graphSensorsLimit}} датчиков!',
  new_graph_add_device_group_modal_confirm_button: 'Подтвердить',
  new_graph_add_device_group_modal_cancel_button: 'Отмена',
  new_graph_select_sensor_heading: 'Выберите датчик',
  new_graph_date_range_selection: 'Выбор диапазона дат',
  new_graph_selected_sensors_heading: 'Выбранные датчики',
  new_graph_selected_sensors_remove_all_tooltip: 'Очистить все',
  new_graph_select_company_message: 'Пожалуйста, выберите компанию',
  new_graph_show_sensors_statistics_label: 'Показать статистику',

  //sensor selection
  new_graph_device_group_label: 'Группа устройств',
  new_graph_device_label: 'Устройство',
  new_graph_sensor_label: 'Датчик',

  //date range selection
  new_graph_average_days_label: 'дней в среднем',
  new_graph_time_series_prediction_period_label: 'Период',
  new_graph_auto_refresh_label: 'Обновить',
  new_graph_period_picker_heading: 'Период',
  new_graph_average_days_heading: 'Средний',
  new_graph_time_series_prediction_period_heading: 'Прогноз временных рядов',
  new_graph_none_option: 'Никто',
  new_graph_day_option_one: '{{count}} день',
  new_graph_day_option_other: '{{count}} дней',
  new_graph_week_option_one: '{{count}} неделя',
  new_graph_week_option_other: '{{count}} недели',
  new_graph_month_option_one: '{{count}} месяц',
  new_graph_month_option_other: '{{count}} месяца',
  new_graph_year_option_one: '{{count}} год',
  new_graph_year_option_other: '{{count}} года',

  //tooltip
  new_graph_current_value_name: 'Текущее',
  new_graph_average_value_name: 'Среднее',
  new_graph_prediction_value_name: 'Прогноз',

  //error
  new_graph_fetch_device_groups_error: 'Не удалось загрузить группы устройств для компании.',
  new_graph_fetch_devices_error: 'Не удалось загрузить устройства для компании.',
  new_graph_fetch_device_config_error: 'Не удалось загрузить конфигурацию выбранного устройства.',
  new_graph_fetch_device_ports_config_error:
    'Не удалось загрузить порты для выбранного устройства.',
  new_graph_fetch_device_flow_error: 'Не удалось загрузить поток для устройства {{deviceName}}.',
  new_graph_fetch_device_flow_avg_error:
    'Не удалось загрузить средний поток для устройства {{deviceName}}.',
  new_graph_fetch_device_readings_error: 'Не удалось загрузить показания для {{deviceName}}.',
  new_graph_fetch_device_readings_avg_error:
    'Не удалось загрузить средние показания для {{deviceName}}.',
  new_graph_fetch_device_on_off_alarms_error:
    'Не удалось загрузить сигналы включения/выключения для устройства {{deviceName}}.',
  new_graph_fetch_device_prediction_error: 'Не удалось загрузить предсказание для {{deviceName}}.',
  new_graph_sensor_already_in_state_error: 'Этот конкретный датчик уже добавлен в список.',

  /* |================|
   * | Billing Report |
   * |================|
   */
  billing_report_header: 'Отчет по оплате',
  billing_report_btn_generate: 'Создать',
  billing_report_device_number: 'Номер устройства',
  billing_report_first_reading_date: 'Дата первого считывания',
  billing_report_last_reading_date: 'Дата последнего считывания',
  billing_report_readings: 'Считывания',
  billing_report_battery: 'Батарея',
  billing_report_signal: 'Сигнал',
  billing_report_total: 'Итого',

  /* |================|
   * | Profile Page   |
   * |================|
   */
  profile_page_change_logo: 'Изменить логотип',
  profile_page_logo_formats_message: 'Допустимые форматы: PNG, JPEG',
  profile_page_name: 'Имя',
  profile_page_email: 'Электронная почта',
  profile_page_language: 'Язык',
  profile_page_password: 'Пароль',
  profile_page_change_language: 'Изменить язык',
  profile_page_update_license: 'Обновить лицензию',
  profile_page_change_password: 'Сменить пароль',
  profile_page_generate: 'Генерировать',
  profile_page_api_token: 'API Токен',
  profile_page_client_id: 'Client ID',
  profile_page_client_secret: 'Client Secret',
  profile_page_show_client_id: 'Показать client ID',
  profile_page_hide_client_id: 'Скрыть client ID',
  profile_page_show_client_secret: 'Показать client secret',
  profile_page_hide_client_secret: 'Скрыть client secret',
  profile_page_api_token_label: 'API Токен',
  profile_page_api_token_valid_for: 'Действителен в течение {{duration}}.',
  profile_page_copy: 'Копировать',
  profile_page_copied_to_clipboard: 'Скопировано в буфер обмена.',
  profile_page_failed_to_copy: 'Не удалось скопировать в буфер обмена.',
  profile_page_token_generated_success: 'Токен успешно сгенерирован.',
  profile_page_token_generate_error: 'Ошибка при генерации токена.',
  profile_page_header: 'Профиль',
  profile_page_user_info_label: 'Информация о пользователе',
  profile_page_license_label: 'Лицензия ',
  profile_page_license_type: 'Тип лицензии',
  profile_page_valid_from: 'Действителен с',
  profile_page_valid_to: 'Действителен до',
  profile_page_max_readings: 'Максимальное количество показаний',
  profile_page_current_count: 'Текущее количество',
  profile_page_first_reading: 'Первое чтение',
  profile_page_last_reading: 'Последнее чтение',
  profile_page_license_status: 'Статус',
  profile_page_renew_license_button: 'Обновить лицензию',
  profile_page_deactivate_license_button: 'Деактивировать лицензию',
  profile_page_valid_license: 'Действующая лицензия',
  profile_page_invalid_license: 'Недействительная лицензия',
  profile_page_deactivate_license_success_message: 'Лицензия деактивирована.',
  profile_page_deactivate_license_error_message: 'Не удалось деактивировать лицензию.',
  profile_page_deactivate_modal_title: 'Деактивация лицензии',
  profile_page_confirm_button: 'Подтвердить',
  profile_page_cancel_button: 'Отмена',
  profile_page_deactivate_license_modal_description:
    'Вы уверены, что хотите деактивировать эту лицензию?',
  profile_page_activate_license_modal_description:
    'Вы уверены, что хотите активировать эту лицензию?',
  profile_page_activate_modal_title: 'Активация лицензии',
  profile_page_license_per_device: 'на устройство',
  profile_page_license_per_reading: 'за чтение',
  profile_page_license_per_sensor: 'на датчик',
  profile_page_license_per_poc: 'на концепцию (POC)',
  profile_page_license_per_remote_node: 'на удаленный узел',
  profile_page_license_partial: 'частичный',
  profile_page_logo_file_format_error: 'Недопустимый тип файла. Пожалуйста, загрузите изображение.',
  profile_page_logo_size_error:
    'Размер файла превышает 1 МБ. Пожалуйста, загрузите изображение меньшего размера.',
  profile_page_version_info: 'Текущие версии:',

  logo_error_message: 'Не удалось загрузить логотип компании',

  profile_page_country: 'Страна',
  profile_page_timezone: 'Часовой пояс',
  profile_page_address: 'Адрес',
  profile_page_city: 'Город',
  profile_page_municipality: 'Муниципалитет',
  profile_page_area: 'Район',
  profile_page_zip_code: 'Почтовый индекс',
  profile_page_vat_number: 'Идентификационный номер НДС',
  profile_page_edit: 'Редактировать аккаунт',
  profile_page_update_account_success: 'Аккаунт успешно обновлен',
  profile_page_license_info: 'Информация о лицензии',

  /* |===============|
   * | Utility Rates |
   * |===============|
   */

  util_rates: 'Тарифы на коммунальные услуги',

  // table
  util_rates_name: 'Имя',
  util_rates_price: 'Цена',
  util_rates_currency: 'Валюта',
  util_rates_unit: 'Единица',
  util_rates_private: 'Частный',
  util_rate_company: 'Компания',
  util_rate_created: 'Созданный',
  util_rates_updated: 'Обновлено',
  util_rates_actions: 'Действия',
  util_rates_tooltip_inspect: 'Осмотреть',

  // modals
  util_rates_add_modal_header: 'Добавить тариф за коммунальные услуги',
  util_rates_edit_modal_header: 'Редактировать {{name}}',
  util_rates_delete_modal_header: 'Удалить {{name}}',
  util_rates_delete_modal_body:
    'Выбранный тариф за коммунальные услуги будет удален без возможности восстановления.',
  util_rates_confirm: 'Подтверждать',
  util_rates_cancel: 'Отмена',
  util_rates_loading: 'Загрузка...',
  util_rates_error: 'Ошибка...',
  util_rates_error_name_exists: 'Тариф за коммунальные услуги с таким именем уже существует.',

  // errors
  util_rate_fetch_company_error: 'Не удалось загрузить компании',
  util_rate_fetch_util_rates_error: 'Не удалось загрузить тарифы на коммунальные услуги.',

  // footer
  footer_powered_by: 'Υποστηρίζεται από',
  util_rates_name_required: 'Имя обязательно',
  util_rates_price_required: 'Цена обязательна',

  /*
   * |=======|
   * | Icons |
   * |=======|
   */
  icon_type: 'Тип',
  icon_type_device: 'Устройство',
  icon_type_sensor: 'Датчик',

  icon_scope: 'Объем',
  icon_scope_global: 'Глобальный',
  icon_scope_company: 'Компания',
  icon_scope_device: 'Устройство',
  icon_scope_sensor: 'Датчик',

  icon_input_device: 'Устройство',
  icon_input_sensor: 'Датчик',
  icon_input_name: 'Имя',
  icon_input_company: 'Компания',

  icon_btn_add_icon: 'Добавить значок',
  icon_btn_upload_file: 'Загрузить файл',
  icon_btn_cancel: 'Отмена',
  icon_btn_save: 'Сохранять',

  icon_table_name: 'Имя',
  icon_table_scope: 'Объем',
  icon_table_icon: 'Икона',
  icon_table_actions: 'Действия',

  // errors
  icon_error_update_icon: 'Не мог обновить значок',
  icon_error_unsupported_file_type: 'Неверный тип файла. Только JPEG, PNG и SVG разрешены.',
  icon_error_error_occured: 'Произошла ошибка',
  icon_error_enter_name: 'Пожалуйста, введите имя',
  icon_error_enter_icon: 'Пожалуйста, загрузите значок',
  icon_error_select_company: 'Пожалуйста, выберите компанию',
  icon_error_select_device: 'Пожалуйста, выберите устройство',
  icon_error_select_sensor: 'Пожалуйста, выберите датчик',

  /*
   * |=========================|
   * | Customer Billing Report |
   * |=========================|
   */
  customer_billing_report_account_id_table_header: 'Идентификатор счета',
  customer_billing_report_description_table_header: 'Описание',
  customer_billing_report_customer_name_table_header: 'Имя клиента',
  customer_billing_report_street_table_header: 'Улица',
  customer_billing_report_quarter_table_header: 'Квартал',
  customer_billing_report_last_reading_table_header: 'Последнее показание',
  customer_billing_report_last_reading_date_table_header: 'Дата последнего показания',
  customer_billing_report_device_number_table_header: 'Номер устройства',
  customer_billing_report_last_config_date_table_header: 'Дата последней конфигурации',
  customer_billing_report_billing_group_table_header: 'Группа выставления счетов',
  customer_billing_report_meter_serial_table_header: 'Серийный номер',
  customer_billing_report_diameter_table_header: 'Диаметр',
  customer_billing_report_meter_brand_table_header: 'Марка',
  customer_billing_report_meter_model_table_header: 'Модель',
  customer_billing_report_default_error: 'При создании отчета возникла ошибка',
  customer_billing_report_contract_number_table_header: 'Номер договора',
  customer_billing_report_device_name_table_header: 'Название устройства',
  customer_billing_report_sensor_name_table_header: 'Название датчика',

  //license
  license_license_warning: 'Предупреждение о лицензии',
  license_license_warning_per_reading_over_limit_singular: 'типа за чтение превышает лимит',
  license_license_warning_expire_singular: 'скоро истекает',
  license_license_warning_per_reading_over_limit_plural: 'типа за чтения превышают лимит',
  license_license_warning_expire_plural: 'скоро истекают',
  license_max_count_error: 'Максимальное количество не может быть 0',

  license_header: 'Лицензия',
  license_table_company_name: 'Название компании',
  license_table_license_type: 'Тип лицензии',
  license_table_max_count: 'Максимальное количество',
  license_table_valid_from: 'Действителен с',
  license_table_valid_to: 'Действителен до',
  license_table_first_reading_date: 'Дата первого чтения',
  license_table_last_reading_date: 'Дата последнего чтения',
  license_table_active: 'Активный',
  license_table_valid: 'Действителен',
  license_table_prepaid: 'Предоплаченная',
  license_table_yes: 'Да',
  license_table_no: 'Нет',
  license_table_actions: 'Действия',

  license_warning_access_hold: 'Доступ к аккаунту приостановлен',
  license_warning_access_hold_description:
    'Ваш доступ к платформе был временно приостановлен из-за неразрешенного платежа. Мы рекомендуем вам обратиться в нашу службу поддержки или связаться с вашим назначенным представителем, чтобы помочь вам в решении этой проблемы.',
  license_warning_no_valid_license: 'Нет действительной лицензии',
  license_warning_no_valid_license_description:
    'Мы не смогли найти действующую лицензию, связанную с этим аккаунтом. Пожалуйста, обратитесь к вашему назначенному представителю или свяжитесь с нашей службой поддержки для помощи.',
  license_warning_devices_count_limit_reached: 'Достигнуто максимальное количество устройств',
  license_warning_devices_count_limit_reached_description:
    'Вы достигли максимального количества устройств, которые вы можете связать с учетной записью по лицензии. Если вы хотите добавить больше, пожалуйста, свяжитесь с вашим назначенным представителем или обратитесь в нашу службу поддержки за помощью.',
  license_warning_generic_title: 'Нет лицензии',
  license_warning_generic_description: 'Невозможно продолжить из-за проблемы с лицензией.',
  license_info_renew_button: 'Обновить лицензию',
  license_info_deactivate_button: 'Деактивировать лицензию',
  license_info_renew_modal_button: 'Обновить',
  license_info_used_readings: 'Использованные отчеты',
  license_info_readings_left: 'Оставшиеся отчеты',
  license_renew_license_button: 'Обновить',
  license_select_company_warning_message: 'Выберите компанию, чтобы продолжить',
  license_add_button: 'Добавить лицензию',
  license_add_success_message: 'Лицензия успешно создана',
  license_add_error_message: 'В процессе произошла ошибка',
  license_max_devices: 'Максимальное количество устройств',
  license_max_readings: 'Максимальное количество отчетов',
  license_max_sensors: 'Максимальное количество датчиков',
  license_company: 'Компания',
  license_deactivate_warning: 'Это приостановит доступ пользователей к платформе',
  license_activate_warning: 'Это восстановит доступ пользователей к платформе',
  license_activate_license_button: 'Активировать',
  license_deactivate_license_button: 'Деактивировать',
  license_available_licenses: 'Доступные лицензии',
  license_add_license: 'Добавить лицензию',
  license_status_active: 'Активный',
  license_status_inactive: 'Неактивный',
  license_info_activate_button: 'Активировать лицензию',
  license_info_used_devices: 'Использованные устройства',
  license_info_devices_left: 'Оставшиеся устройства',
  license_error_page_access_restricted: 'Доступ ограничен',
  license_valid_license_existing: 'У вас уже есть действующая лицензия этого типа!',
  license_conflicting_license_date: 'В тот же период действует другая лицензия',

  license_date_range: 'Диапазон дат',
  license_validity_period: 'Срок действия',
  provide_period: 'Пожалуйста, укажите период',
  license_table_current_count: 'Текущее количество',

  //Password
  change_password: 'Сменить пароль',
  current_password: 'Текущий пароль',
  new_password: 'Новый пароль',
  confirm_new_password: 'Подтвердите новый пароль',
  customer_info_saved: 'Информация о клиенте сохранена',

  password_min_length: 'Пароль должен содержать не менее 10 символов',
  password_uppercase: 'Пароль должен содержать хотя бы одну заглавную букву',
  password_lowercase: 'Пароль должен содержать хотя бы одну строчную букву',
  password_number: 'Пароль должен содержать хотя бы одну цифру',
  password_special_char: 'Пароль должен содержать хотя бы один специальный символ',
  password_mismatch: 'Пароли не совпадают',

  /*
   * |=========================|
   * |     Reset Password      |
   * |=========================|
   */
  reset_password_check_email_for_reset_link:
    'Проверьте свою электронную почту для получения ссылки на сброс пароля',
  reset_password_default_error_message: 'При попытке сброса пароля произошла ошибка',
  reset_password_change_password_label: 'Изменить пароль',
  reset_password_send_btn: 'Отправить',

  /*
   * |==============================|
   * |  Sensors and Network Config  |
   * |==============================|
   */

  //headers
  sensors_and_network_config_network_config: 'Сетевые настройки устройства',
  sensors_and_network_config_device_details: 'Детали устройства',
  sensors_and_network_config_add_sensor: 'Добавить датчик',

  //messages
  sensors_and_network_save_success: 'Конфигурация успешно сохранена.',
  sensors_and_network_save_error: 'Произошла ошибка при сохранении конфигурации.',
  sensors_and_network_formula_validation_default_error: 'Проверка формулы не удалась.',
  sensors_and_network_config_required_field_error: 'Это поле обязательно для заполнения',

  //labels
  sensors_and_network_config_sensor_index: 'Индекс датчика',
  wildPoint_threshold: 'Порог выброса',
  scale: 'Масштаб',
  precision: 'Точность',
  initial_value: 'Начальное значение',

  //buttons
  sensors_and_network_config_reset_btn: 'Сброс',

  //tooltips
  config_tooltip_select_sensor_icon: 'Выберите значок датчика',
  config_tooltip_sensor_name: 'Имя датчика',
  config_tooltip_enable_disable_sensor: 'Включить/Отключить датчик',
  config_tooltip_reset_sensor: 'Сбросить изменения для этого датчика',
  config_tooltip_reset_all_fields: 'Сбросить все поля к последним сохранённым значениям',
  config_tooltip_delete_sensor: 'Удалить датчик',
  config_tooltip_sensor_description: 'Описание датчика',
  config_tooltip_sensor_model: 'Модель датчика',
  config_tooltip_sensor_serial_number: 'Серийный номер датчика',
  config_tooltip_sensor_manufacturer: 'Производитель датчика',
  config_tooltip_sensor_useInSensorsAggregation:
    'Определяет, должны ли данные использоваться автоматическим агрегатором данных Thingslog.',
  config_tooltip_sensor_visibility:
    'Определяет, должен ли датчик быть видимым в портале решений Thingslog.',
  config_tooltip_sensor_scale: 'Точность после десятичной точки для всех вычислений по формуле.',
  config_tooltip_port_formula:
    'Используется для преобразования необработанных значений ADC в мА или В',
  config_tooltip_sensor_formula:
    'Используется для преобразования X в мА или В в измеренное значение, например, уровень, давление, температура и другие.',
  config_tooltip_sensor_pulseRate: 'Сколько единиц составляет один импульс',
  config_tooltip_sensor_offset:
    'Числовое значение (+ или -), которое будет добавлено к показаниям, отправленным устройством.',
  config_tooltip_sensor_flow_units: 'Единицы измерения расхода - например, м3/ч или кВт/ч',
  config_tooltip_sensor_flow_time_units:
    'Временной период, используемый для вычисления единицы - например, секунды',
  config_tooltip_sensor_flow_conversion_coefficient:
    'Сколько временных единиц необходимо для достижения единицы измерения из необработанных показаний',

  config_tooltip_sensor_diameter: 'Диаметр трубы',
  config_tooltip_sensor_q3: 'Коэффициент Q3 водомера',
  config_tooltip_sensor_r: 'Точность водомера',
  config_tooltip_wildPoint_threshold:
    'Определяет максимальное допустимое изменение между последовательными показаниями датчика. Если оно превышено, пакет считается ошибочным и отбрасывается.',

  /*
   * |==============================|
   * |     Documentation Page       |
   * |==============================|
   */

  documentation_title: 'Документация',
  documentation_platform: 'Документация платформы',
  documentation_data_logger: 'Документация регистратора данных',
  documentation_communication_protocol: 'Документация протокола связи',
  documentation_sign_in_main_menu: 'Регистрация/Вход и Главное меню',
  documentation_account_management: 'Управление учетными записями ThingsLog',
  documentation_user_management: 'Управление пользователями ThingsLog',
  documentation_data_loggers_configuration: 'Настройка регистраторов данных ThingsLog',
  documentation_alarms_value_range_events:
    'Настройка и обзор сигналов тревоги и событий диапазона значений ThingsLog',
  documentation_modbus_slave_devices: 'Настройка параметров порта и датчиков для Modbus-устройств',
  documentation_tasmota_devices: 'Настройка устройств Tasmota для работы с платформой ThingsLog',
  documentation_modbus_setup: 'Настройка Modbus-устройств для работы с контроллерами ThingsLog',
  documentation_licenses: 'Лицензии',
  documentation_old_user_manual: 'Старое руководство пользователя',
  documentation_data_logger_manual: 'Руководство пользователя регистратора данных ThingsLog',
  documentation_data_logger_command_guide: 'Руководство по командам регистратора данных ThingsLog',
  documentation_lora_protocol: 'Открытый протокол данных LoRa',
  documentation_mqtt_protocol: 'Открытый протокол данных MQTT',
  documentation_getting_started_training_guide: 'Руководство по началу обучения',
  documentation_view_pdf: 'Просмотр PDF',

  /*
   * |=====================|
   * | Device Nodes Page  |
   * |=====================|
   */

  device_nodes_table_no_links_found: 'Связи узлов устройств не найдены',
  device_nodes_table_error: 'Не удалось получить связи узлов устройств',
  device_nodes_table_source_device_number: 'Номер исходного устройства',
  device_nodes_table_source_sensor_index: 'Индекс исходного датчика',
  device_nodes_table_target_device_number: 'Номер целевого устройства',
  device_nodes_table_target_sensor_index: 'Индекс целевого датчика',
  device_nodes_table_is_active: 'Активно',

  device_nodes_create_link: 'Создать связь',
  device_nodes_source_device_required: 'Исходное устройство обязательно',
  device_nodes_source_device: 'Исходное устройство',
  device_nodes_sensor_index_required: 'Индекс датчика обязателен',
  device_nodes_sensor_index_min: 'Индекс датчика должен быть не менее 0',
  device_nodes_source_sensor_index: 'Индекс исходного датчика',
  device_nodes_target_device_required: 'Целевое устройство обязательно',
  device_nodes_target_device: 'Целевое устройство',
  device_nodes_target_sensor_index: 'Индекс целевого датчика',
  device_nodes_is_active: 'Активно',
  device_nodes_create_link_button: 'Создать связь',
  device_nodes_same_device_error: 'Исходное и целевое устройство не могут быть одинаковыми',

  device_nodes_delete_links: 'Удалить ссылки',
  device_nodes_device_required: 'Устройство обязательно',
  device_nodes_device: 'Устройство',
  device_nodes_role_required: 'Роль обязательна',
  device_nodes_role: 'Роль',
  device_nodes_role_source: 'Источник',
  device_nodes_role_target: 'Цель',
  device_nodes_sensor_index: 'Датчик (Опционально)',
  device_nodes_no_sensors_available: 'Нет доступных датчиков',
  device_nodes_sensor_optional: 'Оставьте пустым, чтобы удалить все ссылки устройства',
  device_nodes_delete_warning: 'Внимание: Это действие нельзя отменить!',
  device_nodes_delete_button: 'Удалить ссылки',

  /*
   * |======================|
   * | Scheduled Reports   |
   * |======================|
   */
  // Generated Reports Page
  generated_reports_header: 'Созданные отчеты',
  generated_reports_select_company_message:
    'Пожалуйста, выберите компанию для просмотра созданных отчетов',
  generated_reports_default_error: 'Произошла ошибка при получении созданных отчетов',
  generated_reports_config_button: 'Конфигурация',
  generated_reports_config_name_header: 'Имя конфигурации отчета',
  generated_reports_date_header: 'Дата отчета',
  generated_reports_type_header: 'Тип отчета',
  generated_reports_file_name_header: 'Имя файла',
  generated_reports_parameters_header: 'Параметры',

  // Report Configs Page
  report_configs_header: 'Конфигурации отчетов',
  report_configs_select_company_message:
    'Пожалуйста, выберите компанию для управления конфигурациями отчетов',
  report_configs_default_error: 'Произошла ошибка при получении конфигураций отчетов',
  report_configs_name_header: 'Имя отчета',
  report_configs_type_header: 'Тип отчета',
  report_configs_occurrence_header: 'Частота',
  report_configs_device_groups_header: 'Группы устройств',
  report_configs_email_list_header: 'Список электронной почты',
  report_configs_start_date_header: 'Дата начала',
  report_configs_end_date_header: 'Дата окончания',
  report_configs_next_execution_header: 'Следующее выполнение',
  report_configs_actions_header: 'Действия',
  report_configs_delete_action: 'Удалить',
  report_configs_delete_success: 'Конфигурация отчета успешно удалена',
  report_configs_delete_error: 'Произошла ошибка при удалении конфигурации отчета',
  report_configs_create_button: 'Создать конфигурацию отчета',
  report_configs_edit_action: 'Редактировать',

  // Report Config Form
  report_config_form_report_name: 'Имя отчета',
  report_config_form_report_type: 'Тип отчета',
  report_config_form_occurrence: 'Частота',
  report_config_form_device_groups: 'Группы устройств',
  report_config_form_email_list: 'Список электронной почты',
  report_config_form_email_list_hint: 'Разделите несколько адресов электронной почты запятыми',
  report_config_form_start_date: 'Дата начала',
  report_config_form_end_date: 'Дата окончания',
  report_config_form_calculate: 'Вычислить',
  report_config_form_calc_min: 'Минимум',
  report_config_form_calc_max: 'Максимум',
  report_config_form_calc_average: 'Среднее',
  report_config_form_cancel: 'Отмена',
  report_config_form_create: 'Создать',
  report_config_form_update: 'Обновить',
  report_config_form_field_required: 'Это поле обязательно',
  report_config_form_device_groups_required: 'Необходимо выбрать хотя бы одну группу устройств',
  report_config_form_license_settings: 'Настройки отчета по лицензии',
  report_config_form_license_is_active: 'Активен',
  report_config_form_license_is_valid: 'Действителен',

  // Report Types
  report_type_consumption: 'Отчет о потреблении',
  report_type_consumption_export: 'Экспорт потребления',
  report_type_customer_billing: 'Отчет о выставлении счетов клиентам',
  report_type_alarm: 'Отчет о сигналах тревоги',
  report_type_transmission: 'Отчет о передаче',
  report_type_license: 'Отчет по лицензии',

  // Report Occurrence
  report_occurrence_daily: 'Ежедневно',
  report_occurrence_weekly: 'Еженедельно',
  report_occurrence_monthly: 'Ежемесячно',

  // Create/Edit Pages
  report_config_create_header: 'Создать конфигурацию отчета',
  report_config_create_success: 'Конфигурация отчета успешно создана',
  report_config_create_error: 'Произошла ошибка при создании конфигурации отчета',
  report_config_edit_header: 'Редактировать конфигурацию отчета',
  report_config_update_success: 'Конфигурация отчета успешно обновлена',
  report_config_update_error: 'Произошла ошибка при обновлении конфигурации отчета',
  report_config_fetch_error: 'Произошла ошибка при получении конфигурации отчета',
  report_config_not_found: 'Конфигурация отчета не найдена',
  report_config_form_email_list_required: 'Требуется хотя бы один адрес электронной почты',
  report_config_form_email_invalid: 'Неверный адрес электронной почты: {{email}}',
  report_config_form_email_no_spaces: 'Адреса электронной почты не могут содержать пробелы',
  report_configs_delete_confirm_title: 'Удалить конфигурацию отчета',
  report_configs_delete_confirm_message:
    'Вы уверены, что хотите удалить конфигурацию отчета "{{reportName}}"? Это действие нельзя отменить.',
  report_configs_delete_cancel: 'Отмена',
  report_configs_delete_confirm: 'Удалить',
  report_configs_deleting: 'Удаление...',

  /*
   * |====================|
   * | Sensors Data Page  |
   * |====================|
   */

  // Page
  sensors_data_no_selection_made: 'Выбор не сделан',
  sensors_data_no_selection_subtitle:
    'Используйте элементы управления выше, чтобы выбрать устройство или группу устройств для просмотра их показаний датчиков.',

  // Device Readings Selector Generic
  sensors_data_select_device_group: 'Выбрать группу устройств',
  sensors_data_search_device_group: 'Поиск по названию группы устройств',
  sensors_data_add: 'Добавить',
  sensors_data_select_device: 'Выбрать устройство',
  sensors_data_search_device: 'Поиск по названию или номеру устройства',
  sensors_data_select_sensor: 'Выбрать датчик',
  sensors_data_search_sensor: 'Поиск по названию или индексу датчика',
  sensors_data_select_devices: 'Выбрать устройства',
  sensors_data_select_sensor_type: 'Выбрать тип датчика',
  sensors_data_search_sensor_type: 'Поиск по типу датчика',
  sensors_data_submit: 'Отправить',

  // Device Readings Selector Specific
  sensors_data_select_sensors: 'Выбрать датчики',

  // Selected Items Display
  sensors_data_group: 'Группа',

  // Readings Data Display
  sensors_data_click_to_view_readings: 'Нажмите, чтобы просмотреть показания',
  sensors_data_view_sensor_data_subtitle: 'Просмотр данных датчика и информации об экспорте',
  sensors_data_raw: 'Сырые',
  sensors_data_export: 'Экспорт',
  sensors_data_format: 'Формат',
  sensors_data_csv: 'CSV',
  sensors_data_excel: 'EXCEL',
  sensors_data_device_number: 'Номер устройства',
  sensors_data_device_name: 'Название устройства',
  sensors_data_sensor_name: 'Название датчика',
  sensors_data_date: 'Дата',
  sensors_data_value: 'Значение',
  sensors_data_no_data_available: 'Нет доступных данных',
  sensors_data_sensor_index: 'Индекс датчика',
  sensors_data_counters: 'Счетчики',
  sensors_data_previous: 'Предыдущий',
  sensors_data_delta: 'Дельта',
  sensors_data_collapse: 'Свернуть',

  // Sensors Data Chart
  sensors_data_chart_no_data_available: 'Нет доступных данных',
  sensors_data_chart_no_numeric_data_subtitle:
    'Запрос выполнен успешно, но числовые данные для выбранного диапазона не были возвращены.',
  sensors_data_chart_min: 'мин -',
  sensors_data_chart_max: 'макс -',

  // Sensors Data Map
  sensors_data_map_loading: 'Загрузка карты...',

  //Warranty Data
  manufacturing_date: 'Дата производства',

  warranty_type: 'Тип гарантии',
  warranty_extended_support: 'Расширенная поддержка',
  warranty_basic: 'Базовая',
  warranty_period_months: 'Гарантийный срок',

  warranty_status: 'Статус гарантии',
  warranty_status_UNKNOWN: 'Неизвестно',
  warranty_status_IN_WARRANTY: 'На гарантии',
  warranty_status_EXPIRED: 'Истекла',

  install_date: 'Дата установки',
  install_warranty_exp_date: 'Дата окончания гарантии на установку',
  install_warranty_period_months: 'Гарантийный срок на установку',

  // Mobile Query Preview
  sensors_data_mobile_groups: 'Группа(ы)',
  sensors_data_mobile_sensors: 'Датчик(и)',
  sensors_data_mobile_types: 'Тип(ы)',
  sensors_data_mobile_no_filters_selected: 'Фильтры не выбраны',

  // Quick Sensor Selector
  sensors_data_quick_select_sensor: 'Выберите датчик для просмотра показаний',

  // Mobile Fab Button
  sensors_data_view_table: 'просмотр таблицы',
  sensors_data_view_chart: 'просмотр графика',
  // Fallbacks added to keep locale keys aligned with English.
  confirm_registration_welcome_to_thingslog: 'Welcome to Thingslog!',
  confirm_registration_completed: 'REGISTRATION COMPLETED',
  confirm_registration_failed: 'REGISTRATION FAILED',
  confirm_registration_completed_description:
    'Your registration process is completed. You can login now. If you face issue, contact our support at {{email}}',
  confirm_registration_failed_description:
    'We encountered a problem with registration. If you face issues logging in, please, contact our support at {{email}}',
  confirm_registration_visit_website: 'Visit Our Website',
  confirm_registration_visit_ecommerce: 'Visit Our Online Store',
  device_counter_statistics_must_have_initialized_params:
    'Parameters Q3, R, and Diameter are required on pulse input connected to a water meter sensor.',
  transmissions_page_yes: 'Yes',
  transmissions_page_no: 'No',
  device_groups_add_sensor_device: 'Add sensor and device to group',
  value_range_name_incorrect_time: 'Incorrect time format',
  value_range_error_occurred: 'An error occurred',
  // Dashboard localization additions
  cancel: 'Отмена',
  edit: 'Редактировать',
  save_btn: 'Сохранить',
  resize: 'Изменить размер',
  value: 'Значение',
  time: 'Время',
  dashboards_title: 'Панели',
  dashboard_add_dashboard: 'Добавить Панель',
  dashboard_edit_dashboard: 'Изменить Панель',
  dashboard_delete_dashboard: 'Удалить Панель',
  dashboard_search_dashboards: 'Поиск панели',
  dashboard_search_by_name: 'поиск по имя',
  dashboard_create_dashboard: 'Создать Панель',
  dashboard_save_dashboard: 'Сохранить Панель',
  dashboard_name: 'Панель Имя',
  dashboard_name_required: 'Панель Имя обязательно',
  dashboard_name_max_length: 'Панель Имя должно быть короче 100 символов',
  dashboard_time_period: 'Период',
  dashboard_dashboard_time_period: 'Период панели',
  dashboard_dashboard_time_period_description: 'Период данных по умолчанию для этой панели.',
  dashboard_save_period: 'Сохранить Период',
  dashboard_edit_dashboard_period: 'Изменить Период панели',
  dashboard_period: 'Период панели',
  dashboard_predefined_period: 'Предустановленный период',
  dashboard_period_dashboard: 'Панель',
  dashboard_period_predefined: 'Предустановлено',
  dashboard_period_preset: 'Шаблон',
  dashboard_period_custom: 'Пользовательский',
  dashboard_timespan_today: 'Сегодня',
  dashboard_timespan_yesterday: 'Вчера',
  dashboard_timespan_this_week: 'Эта неделя',
  dashboard_timespan_this_month: 'Этот месяц',
  dashboard_timespan_this_year: 'Этот год',
  dashboard_timespan_past_1d: 'Последний 1 день',
  dashboard_timespan_past_1w: 'Последняя 1 неделя',
  dashboard_timespan_past_1m: 'Последний 1 месяц',
  dashboard_timespan_past_1y: 'Последний 1 год',
  dashboard_start_date_required: 'Запустить date is required',
  dashboard_end_date_required: 'Дата окончания обязательна',
  dashboard_end_date_before_start_error: 'конец дата до начало ошибка',
  dashboard_predefined_period_required: 'предустановлено период обязательно',
  dashboard_default_dashboard_name: 'По умолчанию Панель',
  dashboard_loading: 'Загрузка...',
  dashboard_redirecting: 'Переадресация...',
  dashboards_load_error: 'загрузить ошибка',
  dashboard_load_error: 'загрузить ошибка',
  dashboard_loading_data_sources: 'загрузка данные источники',
  dashboard_data_sources_load_error: 'данные источники загрузить ошибка',
  dashboard_empty_title: 'Создайте первый виджет',
  dashboard_empty_description: 'Добавьте виджет, чтобы начать отображать данные на этой панели.',
  dashboard_confirm_changes_title: 'Подтвердить изменения',
  dashboard_save_layout_confirmation:
    'Вы уверены, что хотите сохранить изменения? Все изменения будут применены к панели.',
  dashboard_save_layout: 'Сохранить макет',
  dashboard_edit_layout: 'Изменить макет',
  dashboard_add_widget: 'Добавить виджет',
  dashboard_widgets: 'Виджеты',
  dashboard_widget: 'Виджет',
  dashboard_untitled_widget: 'Виджет без названия',
  dashboard_no_widgets_yet: 'нет виджеты yet',
  dashboard_create_widget: 'Создать виджет',
  dashboard_save_widget: 'Сохранить виджет',
  dashboard_edit_widget: 'Редактировать виджет',
  dashboard_delete_widget: 'Удалить виджет',
  dashboard_yes_delete: 'Да, удалить',
  dashboard_widget_no_longer_exists: 'Виджет больше не существует.',
  dashboard_widget_delete_confirmation_prefix: 'Это навсегда удалит виджет',
  dashboard_widget_delete_confirmation_suffix: 'Это действие нельзя отменить.',
  dashboards_empty_no_dashboards_title: 'Нет панелей',
  dashboards_empty_no_results_title: 'Нет результатов',
  dashboards_empty_no_dashboards_description: 'Панели еще не созданы.',
  dashboards_empty_no_results_description: 'Нет панелей, соответствующих поиску.',
  dashboard_add_default_dashboard: 'Добавить По умолчанию Панель',
  dashboard_this_dashboard: 'этот панель',
  dashboard_delete_confirmation: 'Вы уверены, что хотите удалить {{name}}?',
  dashboard_no_longer_exists: 'Панель Виджет больше не существует.',
  dashboard_edit_named_dashboard: 'Изменить {{name}}',
  dashboard_fallback_dashboard: 'Панель',
  dashboard_edit_current_dashboard: 'изменить текущий панель',
  dashboard_all_dashboards: 'All Панели',
  dashboard_start_selector_guide: 'начало селектор руководство',
  dashboard_close_dashboards: 'Закрыть панели',
  dashboard_open_dashboards: 'Открыть панели',
  dashboard_edit_period: 'Изменить панель период',
  dashboard_variables: 'Переменные',
  dashboard_hide_app_header: 'Скрыть заголовок приложения',
  dashboard_show_app_header: 'Показать заголовок приложения',
  dashboard_start_tour: 'начало тур',
  dashboard_remove_from_favorites: 'Удалить из избранного',
  dashboard_add_to_favorites: 'Добавить в избранное',
  dashboard_default_dashboard: 'По умолчанию панель',
  dashboard_set_as_default: 'Сделать по умолчанию',
  dashboard_favorite_tooltip: 'Отметить как избранное',
  dashboard_default_tooltip: 'Панель по умолчанию',
  dashboard_widget_type: 'Тип виджета',
  dashboard_widget_type_required: 'Тип виджета обязателен',
  dashboard_widget_type_line_chart: 'Линейный график',
  dashboard_widget_type_bar_chart: 'Столбчатый график',
  dashboard_widget_type_pie_chart: 'Круговая диаграмма',
  dashboard_widget_type_area_chart: 'График области',
  dashboard_widget_type_gauge: 'Индикатор',
  dashboard_widget_type_value: 'Значение',
  dashboard_widget_type_table: 'Таблица',
  dashboard_widget_title: 'Заголовок',
  dashboard_widget_title_required: 'Заголовок обязателен',
  dashboard_widget_title_max_length: 'Заголовок должен быть короче 100 символов',
  dashboard_data_source: 'Источник данных',
  dashboard_data_source_required: 'Источник данных обязателен',
  dashboard_query_settings: 'Настройки запроса',
  dashboard_no_data_sources_available: 'Нет доступных источников данных',
  dashboard_no_data_sources_description:
    'Настройте источник данных панели перед созданием или редактированием виджетов.',
  dashboard_select_data_source_to_configure_query:
    'Выберите источник данных для настройки запроса.',
  dashboard_query_type_not_supported: 'Этот тип запроса пока не поддерживается.',
  dashboard_no_widget_timeframe: 'Нет периода виджета',
  dashboard_no_widget_timeframe_description: 'Этот виджет наследует период панели.',
  dashboard_widget_time_period: 'Период виджета',
  dashboard_widget_time_period_description:
    'Задайте отдельный период для этого виджета или используйте период панели.',
  dashboard_edit_widget_timeframe: 'Изменить период виджета',
  dashboard_edit_widget_timeframe_inherited:
    'Изменить период виджета. Сейчас он наследуется от панели.',
  dashboard_widget_settings: 'Настройки виджета',
  dashboard_shift_scroll_to_zoom: 'Shift + прокрутка для масштаба',
  dashboard_zoom_in: 'Приблизить',
  dashboard_zoom_out: 'Отдалить',
  dashboard_zoom_reset: 'Сбросить масштаб',
  dashboard_inherited_timeframe_label: 'Панель: {{label}}',
  dashboard_edit_timeframe: 'Изменить период',
  dashboard_edit_widget_period: 'Изменить период виджета',
  dashboard_edit_named_widget: 'Изменить {{name}}',
  dashboard_edit_named_widget_period: 'Изменить {{name}} Период',
  dashboard_data_type: 'Тип данных',
  dashboard_data_type_description:
    'Выберите, должны ли запросы предпочитать показания или рассчитанные значения потока.',
  dashboard_readings: 'Показания',
  dashboard_query_time_period_description: 'Выберите временной диапазон для данных запроса.',
  dashboard_battery_level: 'Уровень батареи',
  dashboard_battery_level_description: 'Ограничивает виджет диапазоном процента батареи.',
  dashboard_signal_level: 'Уровень сигнала',
  dashboard_signal_level_description: 'Ограничивает виджет диапазоном процента сигнала.',
  dashboard_signal_values: 'Значения сигнала',
  dashboard_signal_values_description: 'Выберите, какие значения сигнала показывать.',
  dashboard_signal_value_required: 'Выберите хотя бы одно значение сигнала',
  dashboard_transmission_values: 'Значения передач',
  dashboard_transmission_values_description: 'Выберите, какие значения передач показывать.',
  dashboard_transmission_value_required: 'Выберите хотя бы одно значение передачи',
  dashboard_days: 'Дни',
  dashboard_transmissions: 'Передачи',
  dashboard_count: 'Количество',
  dashboard_unit_days: 'дн.',
  dashboard_transmitting: 'Передаёт',
  devices: 'Устройства',
  dashboard_device_sensor: 'Датчик устройства',
  dashboard_device_sensor_description: 'Выберите устройство и датчик для этого виджета.',
  dashboard_device_required: 'Устройство обязательно',
  dashboard_sensor_required: 'Датчик обязателен',
  dashboard_devices_optional_description:
    'Pick устройства to include. Leave empty to include all устройства.',
  dashboard_no_devices_selected_uses_all:
    'Устройства не выбраны. Виджет будет использовать все устройства.',
  dashboard_device_groups: 'Группы устройств',
  dashboard_device_groups_description: 'Выберите одну или несколько групп устройств для запроса.',
  dashboard_select_one_device_group_required: 'Выберите хотя бы одну группу устройств',
  dashboard_device_groups_optional_description:
    'Дополнительные источники групп для смешанного запроса.',
  dashboard_no_groups_selected: 'Группы не выбраны.',
  dashboard_device_sensors: 'Датчики устройств',
  dashboard_device_sensors_description:
    'Добавьте пары устройства и датчика, которые нужно прочитать.',
  dashboard_device_sensors_optional_description:
    'Необязательные пары номеров устройств и индексов датчиков.',
  dashboard_add_device_sensor_required: 'Добавьте хотя бы один датчик устройства',
  dashboard_add_device_sensor: 'Добавить Датчик устройства',
  dashboard_remove_device_sensor: 'Remove устройство датчик',
  dashboard_device_sensor_types: 'Типы датчиков устройств',
  dashboard_device_sensor_types_description:
    'Выберите устройства и тип датчика, который нужно читать с них.',
  dashboard_device_sensor_types_optional_description:
    'Необязательные группы устройств, сопоставленные по типу датчика.',
  dashboard_add_device_sensor_type_required: 'Добавьте хотя бы один тип датчика устройства',
  dashboard_sensor_type: 'Датчик Тип',
  dashboard_add_sensor_type: 'Добавить Датчик Тип',
  dashboard_remove_sensor_type: 'Удалить тип датчика',
  dashboard_variable: 'переменная',
  dashboard_sensor_index_option: 'Датчик {{index}}',
  dashboard_visualization: 'Визуализация',
  dashboard_visualization_description: 'Параметры отображения и стиль графика',
  dashboard_visualization_show_grid: 'Показывать сетку',
  dashboard_visualization_show_legend: 'Показывать легенду',
  dashboard_visualization_render_legend_aside: 'Легенда сбоку',
  dashboard_visualization_show_legend_aside: 'Легенда сбоку',
  dashboard_visualization_show_x_axis_labels: 'Показывать подписи оси X',
  dashboard_visualization_show_y_axis_labels: 'Показывать подписи оси Y',
  dashboard_visualization_line_thickness: 'Толщина линии',
  dashboard_visualization_interpolation: 'Интерполяция',
  dashboard_visualization_show_points: 'Показывать точки',
  dashboard_visualization_points_hidden_helper:
    'Точки автоматически скрываются, если временной ряд содержит больше {{count}} точек.',
  dashboard_visualization_stack_series: 'Складывать ряды',
  dashboard_visualization_fill_opacity: 'Непрозрачность заливки',
  dashboard_visualization_orientation: 'Ориентация',
  dashboard_visualization_grouping: 'Группировка',
  dashboard_visualization_bar_thickness: 'Толщина столбца',
  dashboard_visualization_shape: 'Форма',
  dashboard_visualization_gauge_type: 'Тип индикатора',
  dashboard_visualization_bar_orientation: 'Ориентация столбца',
  dashboard_visualization_minimum: 'Минимум',
  dashboard_visualization_maximum: 'Максимум',
  dashboard_visualization_gauge_color: 'Цвет индикатора',
  dashboard_visualization_value_color: 'Основной цвет',
  dashboard_visualization_value_prefix: 'Префикс',
  dashboard_visualization_value_suffix: 'Суффикс',
  dashboard_visualization_value_stacked: 'Префикс сверху, суффикс снизу',
  dashboard_visualization_value_compact: 'Компактные числа',
  dashboard_visualization_value_target: 'Цель',
  dashboard_visualization_value_show_target_percentage: 'Показать % от цели',
  dashboard_visualization_value_text_color: 'Пользовательский цвет текста',
  dashboard_visualization_colors: 'Цвета',
  dashboard_value_percent_of_target: '{{percent}}% от цели',
  dashboard_value_percent_above_target: '{{percent}}% выше цели',
  dashboard_visualization_show_value: 'Показывать значение',
  dashboard_visualization_show_min_max: 'Показывать мин./макс.',
  dashboard_visualization_show_thresholds: 'Показывать пороги',
  dashboard_visualization_paginate_rows: 'Разбивать строки на страницы',
  dashboard_visualization_thresholds: 'Пороги',
  dashboard_visualization_add_threshold: 'Добавить порог',
  dashboard_visualization_level: 'Уровень',
  dashboard_visualization_label: 'Метка',
  dashboard_visualization_color: 'Цвет',
  dashboard_visualization_remove_threshold: 'Удалить порог',
  dashboard_visualization_threshold_warning: 'Предупреждение',
  dashboard_visualization_threshold_critical: 'Критично',
  dashboard_visualization_threshold_named: 'Порог {{index}}',
  dashboard_visualization_option_fine: 'Тонкая',
  dashboard_visualization_option_standard: 'Стандарт',
  dashboard_visualization_option_bold: 'Жирная',
  dashboard_visualization_option_straight: 'Прямая',
  dashboard_visualization_option_smooth: 'Плавная',
  dashboard_visualization_option_stepped: 'Ступенчатая',
  dashboard_visualization_option_subtle: 'Легкая',
  dashboard_visualization_option_balanced: 'Сбалансированная',
  dashboard_visualization_option_solid: 'Сплошная',
  dashboard_visualization_option_vertical: 'Вертикально',
  dashboard_visualization_option_horizontal: 'Горизонтально',
  dashboard_visualization_option_grouped: 'Сгруппированная',
  dashboard_visualization_option_stacked: 'Сложенная',
  dashboard_visualization_option_slim: 'Узкая',
  dashboard_visualization_option_regular: 'Обычный',
  dashboard_visualization_option_wide: 'Широкая',
  dashboard_visualization_option_pie: 'Круговая',
  dashboard_visualization_option_donut: 'Кольцевая',
  dashboard_visualization_option_dial: 'Шкала',
  dashboard_visualization_option_bar: 'Столбец',
  dashboard_add_variable: 'Добавить Переменная',
  dashboard_edit_variable: 'Изменить Переменная',
  dashboard_delete_variable: 'Удалить Переменная',
  dashboard_variable_no_longer_exists: 'Переменная больше не существует.',
  dashboard_edit_named_variable: 'Изменить {{name}}',
  dashboard_variable_edit_mode_description:
    'Локальные изменения влияют только на эту панель. Удаленные изменения обновляют сохраненную переменную.',
  dashboard_local: 'Локально',
  dashboard_remote: 'Удаленно',
  dashboard_variable_name: 'Имя',
  dashboard_variable_name_required: 'Имя is required',
  dashboard_variable_name_pattern: 'переменная имя pattern',
  dashboard_variable_label: 'Метка',
  dashboard_variable_label_required: 'Метка is required',
  dashboard_variable_single: 'Одна',
  dashboard_variable_multi: 'Несколько',
  dashboard_variable_value: 'Значение',
  dashboard_variable_values: 'Значения',
  dashboard_variable_value_required: 'Значение is required',
  dashboard_variable_at_least_one_value_required: 'Требуется хотя бы одно значение',
  dashboard_variable_values_helper: 'Разделяйте несколько значений запятыми.',
  dashboard_apply_locally: 'Применить locally',
  dashboard_no_variables_yet: 'Нет переменных',
  dashboard_no_variables_description: 'Для этой панели пока нет переменных.',
  dashboard_variable_value_count: '{{count}} значение',
  dashboard_empty_value: 'Пусто',
  dashboard_open_variable_actions: 'Открыть {{name}} actions',
  dashboard_variable_delete_confirmation_prefix: 'Это навсегда удалит переменную',
  dashboard_no_data_available: 'Нет доступных данных',
  dashboard_widget_failed_to_load_data: 'Не удалось загрузить данные',
  dashboard_click_to_retry: 'Нажмите, чтобы повторить',
  dashboard_chart_sampled_points_tooltip:
    'Показана выборка реальных точек данных. Увеличьте масштаб, чтобы увидеть пропущенные точки.',
  dashboard_chart_all_points_tooltip: 'Показаны все точки данных в текущем виде.',
  dashboard_widget_no_areas: 'У этого виджета нет областей для отображения.',
  dashboard_widget_no_bars: 'У этого виджета нет столбцов для отображения.',
  dashboard_widget_no_points: 'У этого виджета нет точек для построения.',
  dashboard_widget_no_slices: 'У этого виджета нет секторов для отображения.',
  dashboard_widget_too_many_slices: 'Слишком много секторов для отображения',
  dashboard_widget_too_many_slices_description:
    'В этом виджете {{slices}} секторов. Отрисовка всех замедлит загрузку и работу с панелью, а диаграмму будет трудно читать.',
  dashboard_widget_render_anyway: 'Всё равно показать',
  dashboard_table_settings_missing: 'Настройки таблицы отсутствуют.',
  dashboard_widget_no_rows: 'У этого виджета нет строк для отображения.',
  dashboard_gauge_settings_missing: 'Настройки индикатора отсутствуют.',
  dashboard_value_settings_missing: 'Настройки значения отсутствуют.',
  dashboard_widget_no_value: 'У этого виджета нет значения для отображения.',
  dashboard_widget_no_numeric_value: 'У этого виджета нет числового значения для отображения.',
  dashboard_timestamp: 'Время',
  dashboard_alarm_type: 'Тип тревоги',
  dashboard_alarm_count: 'Количество тревог',
  dashboard_level: 'Уровень',
  dashboard_series_index: 'Серия {{index}}',
  dashboard_gauge_normal: 'Нормально',
  dashboard_gauge_threshold: 'Порог',
  dashboard_start_named_guide: 'Запустить {{title}} руководство',
  dashboard_expand_named: 'Развернуть {{title}}',
  dashboard_expand_named_widget: 'Развернуть виджет {{title}}',
  dashboard_close_named: 'Закрыть {{title}}',
  dashboard_close_named_widget: 'Закрыть {{title}} виджет',
  dashboard_close_expanded_named_widget: 'Закрыть развернутый виджет {{title}}',
  dashboard_tour_header_dashboards: 'Справка: заголовок панели.',
  dashboard_tour_header_settings: 'Справка: заголовок настройки.',
  dashboard_tour_header_title: 'Справка: заголовок заголовок.',
  dashboard_tour_header_period: 'Справка: заголовок период.',
  dashboard_tour_header_layout: 'Справка: заголовок макет.',
  dashboard_tour_header_add_widget: 'Справка: заголовок добавление виджет.',
  dashboard_tour_header_variables: 'Справка: заголовок переменные.',
  dashboard_tour_header_toggle_app_header: 'Справка: заголовок переключение приложение заголовок.',
  dashboard_tour_dashboard_canvas: 'Справка: панель рабочая область.',
  dashboard_tour_selection_search: 'Справка: выбор поиск.',
  dashboard_tour_selection_add: 'Справка: выбор добавление.',
  dashboard_tour_selection_list: 'Справка: выбор список.',
  dashboard_tour_selection_favorite: 'Справка: выбор избранное.',
  dashboard_tour_selection_default: 'Справка: выбор по умолчанию.',
  dashboard_tour_selection_all: 'Справка: выбор все.',
  dashboard_tour_widget_title: 'Справка: виджет заголовок.',
  dashboard_tour_widget_type: 'Справка: виджет тип.',
  dashboard_tour_widget_data_source: 'Справка: виджет данные источник.',
  dashboard_tour_query_single_device: 'Справка: запрос один устройство.',
  dashboard_tour_query_single_sensor: 'Справка: запрос один датчик.',
  dashboard_tour_query_specific_devices: 'Справка: запрос конкретные устройства.',
  dashboard_tour_query_battery_range: 'Справка: запрос батарея диапазон.',
  dashboard_tour_query_device_groups: 'Справка: запрос устройство группы.',
  dashboard_tour_query_device_sensor_list: 'Справка: запрос устройство датчик список.',
  dashboard_tour_query_device_sensor_device: 'Справка: запрос устройство датчик устройство.',
  dashboard_tour_query_device_sensor_sensor: 'Справка: запрос устройство датчик датчик.',
  dashboard_tour_query_device_sensor_add: 'Справка: запрос устройство датчик добавление.',
  dashboard_tour_query_device_type_list: 'Справка: запрос устройство тип список.',
  dashboard_tour_query_device_type_devices: 'Справка: запрос устройство тип устройства.',
  dashboard_tour_query_device_type_sensor_type: 'Справка: запрос устройство тип датчик тип.',
  dashboard_tour_query_device_type_add: 'Справка: запрос устройство тип добавление.',
  dashboard_tour_query_prefer_flow: 'Справка: запрос предпочтение поток.',
  dashboard_tour_query_timespan_mode: 'Справка: запрос интервал режим.',
  dashboard_tour_query_timespan_preset: 'Справка: запрос интервал шаблон.',
  dashboard_tour_query_timespan_custom: 'Справка: запрос интервал пользовательский.',
  dashboard_tour_widget_actions: 'Справка: виджет действия.',
  dashboard_tour_widget_delete: 'Справка: виджет удаление.',
  dashboard_tour_dashboard_name: 'Справка: панель имя.',
  dashboard_tour_dashboard_period: 'Справка: панель период.',
  dashboard_tour_dashboard_timespan_mode: 'Справка: панель интервал режим.',
  dashboard_tour_dashboard_timespan_preset: 'Справка: панель интервал шаблон.',
  dashboard_tour_dashboard_timespan_custom: 'Справка: панель интервал пользовательский.',
  dashboard_tour_variable_add: 'Справка: переменная добавление.',
  dashboard_tour_variable_row: 'Справка: переменная строка.',
  dashboard_tour_variable_actions: 'Справка: переменная действия.',
  dashboard_tour_variable_name_label: 'Справка: переменная имя метка.',
  dashboard_tour_variable_type: 'Справка: переменная тип.',
  dashboard_tour_variable_source: 'Справка: переменная источник.',
  dashboard_tour_variable_value: 'Справка: переменная значение.',
  dashboard_tour_variable_actions_form: 'Справка: переменная действия форма.',
  dashboard_dialog_currently_open: 'Диалог сейчас открыт.',
};

export default i18n_ru;
